import React, { Component } from "react";
import "./CustomFieldsList.css";
import ic_clear_24px from "../../assets/images/ic_clear_24px@2x.png";
import Header from "../Common/Header/Header";
import settingIcon from "../../assets/images/setting_icon.png";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import moment from "moment";
import InputMask from "react-input-mask";
import "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// - -   jQUARY INSTANCE  - -//
// - - - - - - - - - - - - - //
import $ from "jquery";
window.jQuery = $;
window.$ = $;
global.jQuery = $;
var Modal = require("react-bootstrap-modal");
require("react-bootstrap-modal/lib/css/rbm-patch.css");
const uuidv1 = require("uuid/v1");
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

// const grid = 10;

const getItemStyle = (isDragging, draggableStyle) => ({
  cursor: "all-scroll",
  cursor: isDragging ? "all-scroll" : "all-scroll",
  margin: isDragging ? "-25px 10px 5px -400px" : "",
  // marginTop:isDragging?"-80px":"",
  // background: isDragging ? "lightgreen" : "grey",

  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  cursor: "all-scroll",
  cursor: isDraggingOver ? "all-scroll" : "all-scroll",
});

class CustomFieldsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordupdating: "",
      actionsubmission: "added",
      upadteableid: "",
      updateabledata: "",
      tagsFormHtml: "",
      isLoading: true,
      CustomListFields: [],
      modalOpen: false,
      ad_modalOpen: false,
      deletestatus: false,
      UnitDescModalOpen: false,
      RateModalOpen: false,
      FactorModalOpen: false,
      AmountModalOpen: false,
      DaysInWeekdModalOpen: false,
      CappedModalOpen: false,
      DateFromModalOpen: false,
      DateToModalOpen: false,
      ChartModalOpen: false,
      ChartCodeModalOpen: false,
      FlagModalOpen: false,
      PaymentFlagModalOpen: false,
      CalcDaysModalOpen: false,
      CalcWeeksModalOpen: false,
      //Setup Form
      setupModalOpen: false,
      setupTrackingFieldEditModal: false,
      setup_chartSort: "",
      setup_chartCode: "",
      tracking_order: "",
      typeOfTrackingField: "",
      d_value_input: "",
      d_value_options: "",
      tracking_length: "",
      tracking_prompt: "",
      editTrackRow: "",
      options: "",
      values: "",
      editableOptionKey: "",
      dropdown_elements: [],
      trackingList: [],
      trackingfiled_date: moment(),
      updateDataModal: false,
      tracking_prompt_error: false,
      trackingfiled_date_error: false,
      tracking_d_value_input_error: false,
      tracking_order_error: false,
      setupForm_chartSortValid: false,
      setupForm_chartCodeValid: false,
      tracking_length_error: false,
      order_present_before: false,
      drop_listModal: false,
      options_error: false,
      values_error: false,
      editDropDown: false,
      datePickerDisable: false,
      setup_data: {},
      setupErrors: {
        // setup_tenantNameErr: "",
        // setup_companyIdErr: "",
        // setup_urlErr: "",
        // setup_TPAkeyErr: "",
        // setup_TPAPasswordErr: "",
        // setup_DFAkeyErr: "",
        // digital_urlErr: "",
        // setup_DFAPasswordErr: "",
        setup_chartSortErr: "",
        setup_chartCodeErr: "",
      },
      listHandler: {
        CustomFields: [
          {
            DBField: null,
            Desc: "Factor",
            Hide: null,
            Length: null,
            Order: 4,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Units",
            Hide: null,
            Length: null,
            Order: 1,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Unit Desc",
            Hide: null,
            Length: null,
            Order: 2,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Rate",
            Hide: null,
            Length: null,
            Order: 3,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Amount",
            Hide: null,
            Length: null,
            Order: 5,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Capped Amount",
            Hide: null,
            Length: null,
            Order: 6,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Days in Week",
            Hide: null,
            Length: null,
            Order: 7,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Date From:",
            Hide: null,
            Length: null,
            Order: 8,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Date To:",
            Hide: null,
            Length: null,
            Order: 9,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
          {
            DBField: null,
            Desc: "Chart Sort",
            Hide: null,
            Length: null,
            Order: 10,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },

          {
            DBField: null,
            Desc: "Chart Code",
            Hide: null,
            Length: null,
            Order: 11,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },

          {
            DBField: null,
            Desc: "Flag:",
            Hide: null,
            Length: null,
            Order: 12,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },

          {
            DBField: null,
            Desc: "Payment Flag:",
            Hide: null,
            Length: null,
            Order: 13,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },

          {
            DBField: null,
            Desc: "Calc Days",
            Hide: null,
            Length: null,
            Order: 14,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },

          {
            DBField: null,
            Desc: "Calc Weeks",
            Hide: null,
            Length: null,
            Order: 15,
            Readonly: null,
            Required: null,
            Script: null,
            Tag: null,
            Type: null,
            Validate: null,
            Value: "",
          },
        ],
      },
      pmt_code: "",
      desc: "",
      TBA: null,
      unit: 0,
      unit_dbfield: null,
      unit_validate: null,
      unit_hide: null,
      unitC_hide:null,
      unit_readonly: null,
      unit_required: null,
      unit_length: null,
      unit_script: null,
      unit_tag: null,
      unit_type: null,
      unit_order: 1,
      unit_desc: null,

      unit_desc_dbfield: null,
      unit_desc_validate: null,
      unit_desc_hide: null,
      unitC_desc_hide: null,
      unit_desc_readonly: null,
      unit_desc_required: null,
      unit_desc_length: null,
      unit_desc_script: null,
      unit_desc_tag: null,
      unit_desc_type: null,
      unit_desc_order: 2,

      rate: 0,
      rate_dbfield: null,
      rate_validate: null,
      rate_hide: null,
      rateC_hide: null,
      rate_readonly: null,
      rate_required: null,
      rate_length: null,
      rate_script: null,
      rate_tag: null,
      rate_type: null,
      rate_order: 3,

      factor: 0,
      factor_dbfield: null,
      factor_validate: null,
      factor_hide: null,
      factorC_hide: null,
      factor_readonly: null,
      factor_required: null,
      factor_length: null,
      factor_script: null,
      factor_tag: null,
      factor_type: null,
      factor_order: 4,

      amount: 0,
      amount_dbfield: null,
      amount_validate: null,
      amount_hide: null,
      amountC_hide: null,
      amount_readonly: null,
      amount_required: null,
      amount_length: null,
      amount_script: null,
      amount_tag: null,
      amount_type: null,
      amount_order: 5,
      handlechangeamount: "",

      capped_amount: null,
      capped_amount_dbfield: null,
      capped_amount_validate: null,
      capped_amount_hide: null,
      cappedC_amount_hide: null,
      capped_amount_readonly: null,
      capped_amount_required: null,
      capped_amount_length: null,
      capped_amount_script: null,
      capped_amount_tag: null,
      capped_amount_type: null,
      capped_amount_order: 6,
      days_in_week: null,
      days_in_week_dbfield: null,
      days_in_week_validate: null,
      days_in_week_hide: null,
      daysC_in_week_hide: null,
      days_in_week_readonly: null,
      days_in_week_required: null,
      days_in_week_length: null,
      days_in_week_script: null,
      days_in_week_tag: null,
      days_in_week_type: null,
      days_in_week_order: 7,
      startDate: moment(),
      startDate_dbfield: null,
      startDate_validate: null,
      startDate_hide: null,
      startDateC_hide: null,
      startDate_readonly: null,
      startDate_required: null,
      startDate_length: null,
      startDate_script: null,
      startDate_tag: null,
      startDate_type: null,
      startDate_order: 8,

      endDate: moment().add(1, "days"),
      endDate_dbfield: null,
      endDate_validate: null,
      endDate_hide: null,
      endDateC_hide: null,
      endDate_readonly: null,
      endDate_required: null,
      endDate_length: null,
      endDate_script: null,
      endDate_tag: null,
      endDate_type: null,
      endDate_order: 9,

      chart_sort: null,
      chart_sort_dbfield: null,
      chart_sort_validate: null,
      chart_sort_hide: null,
      chartC_sort_hide: null,
      chart_sort_readonly: null,
      chart_sort_required: null,
      chart_sort_length: null,
      chart_sort_script: null,
      chart_sort_tag: null,
      chart_sort_type: null,
      chart_sort_order: 10,
      chart_code: null,
      chart_code_dbfield: null,
      chart_code_validate: null,
      chart_code_hide: null,
      chart_code_readonly: null,
      chart_code_required: null,
      chart_code_length: null,
      chart_code_script: null,
      chart_code_tag: null,
      chart_code_type: null,
      chart_code_order: 11,
      flag: null,
      flag_dbfield: null,
      flag_validate: null,
      flag_hide: null,
      flagC_hide: null,
      flag_readonly: null,
      flag_required: null,
      flag_length: null,
      flag_script: null,
      flag_tag: null,
      flag_type: null,
      flag_order: 12,
      payment_flag: null,
      payment_flag_dbfield: null,
      payment_flag_validate: null,
      payment_flag_hide: null,
      paymentC_flag_hide: null,
      payment_flag_readonly: null,
      payment_flag_required: null,
      payment_flag_length: null,
      payment_flag_script: null,
      payment_flag_tag: null,
      payment_flag_type: null,
      payment_flag_order: 13,
      calc_days: null,
      calc_days_dbfield: null,
      calc_days_validate: null,
      calc_days_hide: null,
      calcC_days_hide: null,
      calc_days_readonly: null,
      calc_days_required: null,
      calc_days_length: null,
      calc_days_script: null,
      calc_days_tag: null,
      calc_days_type: null,
      calc_days_order: 14,
      calc_weeks: null,
      calc_weeks_dbfield: null,
      calc_weeks_validate: null,
      calc_weeks_hide: null,
      calcC_weeks_hide: null,
      calc_weeks_readonly: null,
      calc_weeks_required: null,
      calc_weeks_length: null,
      calc_weeks_script: null,
      calc_weeks_tag: null,
      calc_weeks_type: null,
      calc_weeks_order: 15,
      formErrors: {
        pmt_code: "",
        desc: "",
        unit: "",
        unit_desc: "",
        rate: "",
        factor: "",
        amount: "",
        capped_amount: "",
        days_in_week: "",
        chart_sort: "",
        chart_code: "",
        flag: "",
        payment_flag: "",
      },
      chart_sortValid: "",
      payment_flagValid: "",
      flagValid: "",
      PmtCodeValid: "",
      unit_descValid: "",
      descValid: "",
      days_in_weekValid: "",
      unitValid: "",
      rateValid: "",
      amountValid: "",
      chart_codeValid: "",
      capped_amountValid: "",
      factorValid: "",
      formValid: "",
      isActive: "",
      userTypeForRoleManagement: localStorage.getItem("userType"),
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    if (
      this.state.userTypeForRoleManagement === "Approver" ||
      this.state.userTypeForRoleManagement === "Operator" ||
      this.state.userTypeForRoleManagement === "Operator/Approver"
    ) {
      this.props.history.push("/dashboard");
    }
  }
  onDragEnd(result) {
    if (!result.destination) {
      return;
    }


    var items;
    if (
      result.destination.droppableId === "hide_detail" &&
      result.source.droppableId === "tagsForm"
    ) {
      items = reorder(
        this.state.listHandler.CustomFields,
        result.source.index,
        result.destination.index
      );
      if (result.draggableId === "Units") {
        items.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 1;
          }
        });
        this.setState({ unit_hide: "checked" },()=>console.log("TESTTT",this.state.unit_hide,items));
      }
      if (result.draggableId === "Unit Desc") {
        items.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 1;
          }
        });
        this.setState({ unit_desc_hide: "checked" });
      }

      if (result.draggableId === "Rate") {
        items.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 1;
          }
        });
        this.setState({ rate_hide: "checked" });
      }

      if (result.draggableId === "Factor") {
        items.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 1;
          }
        });
        this.setState({ factor_hide: "checked" });
      }

      if (result.draggableId === "Amount") {
        items.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 1;
          }
        });
        this.setState({ amount_hide: "checked" });
      }

      if (result.draggableId === "Capped Amount") {
        items.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 1;
          }
        });
        this.setState({ capped_amount_hide: "checked" });
      }
      if (result.draggableId === "Days in Week") {
        items.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 1;
          }
        });
        this.setState({ days_in_week_hide: "checked" });
      }

      if (result.draggableId === "Date From:") {
        items.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 1;
          }
        });
        this.setState({ startDate_hide: "checked" });
      }

      if (result.draggableId === "Date To:") {
        items.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 1;
          }
        });
        this.setState({ endDate_hide: "checked" });
      }

      if (result.draggableId === "Chart Sort") {
        items.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 1;
          }
        });
        this.setState({ chart_sort_hide: "checked" });
      }
      if (result.draggableId === "Chart Code") {
        items.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 1;
          }
        });
        this.setState({ chart_code_hide: "checked" });
      }

      if (result.draggableId === "Flag:") {
        items.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 1;
          }
        });
        this.setState({ flag_hide: "checked" });
      }

      if (result.draggableId === "Payment Flag:") {
        items.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 1;
          }
        });
        this.setState({ payment_flag_hide: "checked" });
      }

      if (result.draggableId === "Calc Days") {
        items.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 1;
          }
        });
        this.setState({ calc_days_hide: "checked" });
      }
      if (result.draggableId === "Calc Weeks") {
        items.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 1;
          }
        });
        this.setState({ calc_weeks_hide: "checked" });
      }
    }
    if (
      result.destination.droppableId === "tagsForm" &&
      result.source.droppableId === "hide_detail"
    ) {
      items = reorder(
        this.state.listHandler.CustomFields,
        result.source.index,
        result.destination.index - 1
      );
      if (result.draggableId === "Units") {
        items.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 0;
          }
        });
        this.setState({ unit_hide: "" });
      }
      if (result.draggableId === "Unit Desc") {
        items.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 0;
          }
        });
        this.setState({ unit_desc_hide: "" });
      }

      if (result.draggableId === "Rate") {
        items.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 0;
          }
        });
        this.setState({ rate_hide: "" });
      }

      if (result.draggableId === "Factor") {
        items.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 0;
          }
        });
        this.setState({ factor_hide: "" });
      }

      if (result.draggableId === "Amount") {
        items.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 0;
          }
        });
        this.setState({ amount_hide: "" });
      }

      if (result.draggableId === "Capped Amount") {
        items.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 0;
          }
        });
        this.setState({ capped_amount_hide: "" });
      }
      if (result.draggableId === "Days in Week") {
        items.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 0;
          }
        });
        this.setState({ days_in_week_hide: "" });
      }

      if (result.draggableId === "Date From:") {
        items.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 0;
          }
        });
        this.setState({ startDate_hide: "" });
      }

      if (result.draggableId === "Date To:") {
        items.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 0;
          }
        });
        this.setState({ endDate_hide: "" });
      }

      if (result.draggableId === "Chart Sort") {
        items.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 0;
          }
        });
        this.setState({ chart_sort_hide: "" });
      }
      if (result.draggableId === "Chart Code") {
        items.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 0;
          }
        });
        this.setState({ chart_code_hide: "" });
      }

      if (result.draggableId === "Flag:") {
        items.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 0;
          }
        });
        this.setState({ flag_hide: "" });
      }

      if (result.draggableId === "Payment Flag:") {
        items.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 0;
          }
        });
        this.setState({ payment_flag_hide: "" });
      }

      if (result.draggableId === "Calc Days") {
        items.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 0;
          }
        });
        this.setState({ calc_days_hide: "" });
      }
      if (result.draggableId === "Calc Weeks") {
        items.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 0;
          }
        });
        this.setState({ calc_weeks_hide: "" });
      }
    } else {
      items = reorder(
        this.state.listHandler.CustomFields,
        result.source.index,
        result.destination.index
      );
    }
    items.map((field, i) => {
      if (field.Desc === "Units") {
        var order = i + 1;
        this.setState({ unit_order: order });
      }
      if (field.Desc === "Unit Desc") {
        var order = i + 1;
        this.setState({ unit_desc_order: order });
      }
      if (field.Desc === "Rate") {
        var order = i + 1;
        this.setState({ rate_order: order });
      }
      if (field.Desc === "Factor") {
        var order = i + 1;
        this.setState({ factor_order: order });
      }

      if (field.Desc === "Amount") {
        var order = i + 1;
        this.setState({ amount_order: order });
      }

      if (field.Desc === "Capped Amount") {
        var order = i + 1;
        this.setState({ capped_amount_order: order });
      }

      if (field.Desc === "Date From:") {
        var order = i + 1;
        this.setState({ startDate_order: order });
      }

      if (field.Desc === "Date To:") {
        var order = i + 1;
        this.setState({ endDate_order: order });
      }

      if (field.Desc === "Chart Sort") {
        var order = i + 1;
        this.setState({ chart_sort_order: order });
      }
      if (field.Desc === "Chart Code") {
        var order = i + 1;
        this.setState({ chart_code_order: order });
      }
      if (field.Desc === "Flag:") {
        var order = i + 1;
        this.setState({ flag_order: order });
      }
      if (field.Desc === "Payment Flag:") {
        var order = i + 1;
        this.setState({ payment_flag_order: order });
      }
      if (field.Desc === "Calc Days") {
        var order = i + 1;
        this.setState({ calc_days_order: order });
      }
      if (field.Desc === "Calc Weeks") {
        var order = i + 1;
        this.setState({ calc_weeks_order: order });
      }
      if (field.Desc === "Days in Week") {
        var order = i + 1;
        this.setState({ days_in_week_orde: order });
      }
    });
    var test = this.state.listHandler;
    test.CustomFields = items;
    this.setState({
      listHandler: test,
    });
  }

  async componentDidMount() {
    //subconsole.log(moment.tz(this.state.startDate, "America/New_York").format());
    await this.getAllCustomListFields()
      .then((response) => {
        if (response.status) {
          this.setState({ CustomListFields: response.result }, () => {
            console.log("ORDERRR", this.state.CustomListFields);
          });
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log("fetch custopm fields err=>", err);
        this.setState({ isLoading: false });
      });

    try {
      var setup = await this.props.postRequest("/setup/get-list", {});
      if (setup.status) {
        this.setState({
          setup_data: setup.result,
          setup_chartSort: setup.result.Codes.chart_sort,
          setup_chartCode: setup.result.Codes.chart_code,
          trackingList: setup.result.TrackingFields,
        });
      }
      console.log("setup=>", setup);
    } catch (err) {
      this.setState({ isLoading: false });
    }
  }

  getAllCustomListFields() {
    return this.props.postRequest(`/custom-list-fields/get-list/${localStorage.getItem('companyGuid')}`, {});
  }

  deleteCustomListFields(Guid) {
    return this.props.postRequest(
      "/custom-list-fields/delete-custom-list-field",
      { Guid: Guid }
    );
  }

  handleDeleteCustomList = (Guid) => async (event) => {
    var result = window.confirm("Are you sure you want to delete this item?");
    if (result) {
      this.setState({ isLoading: true });
      const response = await this.deleteCustomListFields(Guid);

      if (response.status) {
        await this.getAllCustomListFields().then((response) => {
          if (response.status) {
            this.setState({ CustomListFields: response.result });
          }
        });
        toast.success("Record has deleted successfully.", {
          autoClose: 5000,
        });
        this.setState({ isLoading: false });
      } else {
        toast.error(response.error, { autoClose: 5000 });
        this.setState({ isLoading: false });
      }
    }
  };

  handleUpdateCustomList = (Guid) => async (event) => {
    this.setState({
      isLoading: true,
      recordupdating: true,
    });
    const CustomListField = await this.state.CustomListFields.find(
      (el) => el.Guid === Guid
    );
    if (CustomListField) {
      this.setState({
        updateabledata: CustomListField,
      });

      this.setState({
        pmt_code: this.state.updateabledata.Code,
        desc: this.state.updateabledata.Desc,
        TBA: this.state.updateabledata.TBA,
        upadteableid: Guid,
      });

      var customFieldsarray = this.state.updateabledata.CustomFields;

      customFieldsarray.map((val, key) => {
        if (val.Desc === "Units") {
          this.setState({
            unit: val.Value ? val.Value : 0,
            unit_dbfield: val.DBField,
            unit_validate: val.Validate,
            unit_hide: val.Hide === 1 ? "checked" : "",
            unit_readonly: val.Readonly === 1 ? "checked" : "",
            unit_required: val.Required === 1 ? "checked" : "",
            unit_length: val.Length,
            unit_script: val.Script,
            unit_tag: val.Tag,
            unit_type: val.Type,
            unit_order: val.Order,
          });
        }
        if (val.Desc === "Unit Desc") {
          this.setState({
            unit_desc: val.Value,
            unit_desc_dbfield: val.DBField,
            unit_desc_validate: val.Validate,
            unit_desc_hide: val.Hide === 1 ? "checked" : "",
            unit_desc_readonly: val.Readonly === 1 ? "checked" : "",
            unit_desc_required: val.Required === 1 ? "checked" : "",
            unit_desc_length: val.Length,
            unit_desc_script: val.Script,
            unit_desc_tag: val.Tag,
            unit_desc_type: val.Type,
            unit_desc_order: val.Order,
          });
        }
        if (val.Desc === "Factor") {
          this.setState({
            factor: val.Value ? val.Value : 0,
            factor_dbfield: val.DBField,
            factor_validate: val.Validate,
            factor_hide: val.Hide === 1 ? "checked" : "",
            factor_readonly: val.Readonly === 1 ? "checked" : "",
            factor_required: val.Required === 1 ? "checked" : "",
            factor_length: val.Length,
            factor_script: val.Script,
            factor_tag: val.Tag,
            factor_type: val.Type,
            factor_order: val.Order,
          });
        }
        if (val.Desc === "Rate") {
          this.setState({
            rate: val.Value ? val.Value : 0,
            rate_dbfield: val.DBField,
            rate_validate: val.Validate,
            rate_hide: val.Hide === 1 ? "checked" : "",
            rate_readonly: val.Readonly === 1 ? "checked" : "",
            rate_required: val.Required === 1 ? "checked" : "",
            rate_length: val.Length,
            rate_script: val.Script,
            rate_tag: val.Tag,
            rate_type: val.Type,
            rate_order: val.Order,
          });
        }
        if (val.Desc === "Amount") {
          this.setState({
            amount: val.Value ? val.Value : 0,
            amount_dbfield: val.DBField,
            amount_validate: val.Validate,
            amount_hide: val.Hide === 1 ? "checked" : "",
            amount_readonly: val.Readonly === 1 ? "checked" : "",
            amount_required: val.Required === 1 ? "checked" : "",
            amount_length: val.Length,
            amount_script: val.Script,
            amount_tag: val.Tag,
            amount_type: val.Type,
            amount_order: val.Order,
          });
        }
        if (val.Desc === "Capped Amount") {
          this.setState({
            capped_amount: val.Value,
            capped_amount_dbfield: val.DBField,
            capped_amount_validate: val.Validate,
            capped_amount_hide: val.Hide === 1 ? "checked" : "",
            capped_amount_readonly: val.Readonly === 1 ? "checked" : "",
            capped_amount_required: val.Required === 1 ? "checked" : "",
            capped_amount_length: val.Length,
            capped_amount_script: val.Script,
            capped_amount_tag: val.Tag,
            capped_amount_type: val.Type,
            capped_amount_order: val.Order,
          });
        }
        if (val.Desc === "Days in Week") {
          this.setState({
            days_in_week: val.Value,
            days_in_week_dbfield: val.DBField,
            days_in_week_validate: val.Validate,
            days_in_week_hide: val.Hide === 1 ? "checked" : "",
            days_in_week_readonly: val.Readonly === 1 ? "checked" : "",
            days_in_week_required: val.Required === 1 ? "checked" : "",
            days_in_week_length: val.Length,
            days_in_week_script: val.Script,
            days_in_week_tag: val.Tag,
            days_in_week_type: val.Type,
            days_in_week_order: val.Order,
          });
        }
        if (val.Desc === "Date From:") {
          this.setState({
            startDate: moment(val.Value),
            startDate_dbfield: val.DBField,
            startDate_validate: val.Validate,
            startDate_hide: val.Hide === 1 ? "checked" : "",
            startDate_readonly: val.Readonly === 1 ? "checked" : "",
            startDate_required: val.Required === 1 ? "checked" : "",
            startDate_length: val.Length,
            startDate_script: val.Script,
            startDate_tag: val.Tag,
            startDate_type: val.Type,
            startDate_order: val.Order,
          });
        }
        if (val.Desc === "Date To:") {
          this.setState({
            endDate: moment(val.Value),
            endDate_dbfield: val.DBField,
            endDate_validate: val.Validate,
            endDate_hide: val.Hide === 1 ? "checked" : "",
            endDate_readonly: val.Readonly === 1 ? "checked" : "",
            endDate_required: val.Required === 1 ? "checked" : "",
            endDate_length: val.Length,
            endDate_script: val.Script,
            endDate_tag: val.Tag,
            endDate_type: val.Type,
            endDate_order: val.Order,
          });
        }
        if (val.Desc === "Chart Sort") {
          this.setState({
            chart_sort: val.Value,
            chart_sort_dbfield: val.DBField,
            chart_sort_validate: val.Validate,
            chart_sort_hide: val.Hide === 1 ? "checked" : "",
            chart_sort_readonly: val.Readonly === 1 ? "checked" : "",
            chart_sort_required: val.Required === 1 ? "checked" : "",
            chart_sort_length: val.Length,
            chart_sort_script: val.Script,
            chart_sort_tag: val.Tag,
            chart_sort_type: val.Type,
            chart_sort_order: val.Order,
          });
        }
        if (val.Desc === "Chart Code") {
          this.setState({
            chart_code: val.Value,
            chart_code_dbfield: val.DBField,
            chart_code_validate: val.Validate,
            chart_code_hide: val.Hide === 1 ? "checked" : "",
            chart_code_readonly: val.Readonly === 1 ? "checked" : "",
            chart_code_required: val.Required === 1 ? "checked" : "",
            chart_code_length: val.Length,
            chart_code_script: val.Script,
            chart_code_tag: val.Tag,
            chart_code_type: val.Type,
            chart_code_order: val.Order,
          });
        }
        if (val.Desc === "Flag:") {
          this.setState({
            flag: val.Value,
            flag_dbfield: val.DBField,
            flag_validate: val.Validate,
            flag_hide: val.Hide === 1 ? "checked" : "",
            flag_readonly: val.Readonly === 1 ? "checked" : "",
            flag_required: val.Required === 1 ? "checked" : "",
            flag_length: val.Length,
            flag_script: val.Script,
            flag_tag: val.Tag,
            flag_type: val.Type,
            flag_order: val.Order,
          });
        }
        if (val.Desc === "Payment Flag:") {
          this.setState({
            payment_flag: val.Value,
            payment_flag_dbfield: val.DBField,
            payment_flag_validate: val.Validate,
            payment_flag_hide: val.Hide === 1 ? "checked" : "",
            payment_flag_readonly: val.Readonly === 1 ? "checked" : "",
            payment_flag_required: val.Required === 1 ? "checked" : "",
            payment_flag_length: val.Length,
            payment_flag_script: val.Script,
            payment_flag_tag: val.Tag,
            payment_flag_type: val.Type,
            payment_flag_order: val.Order,
          });
        }
        if (val.Desc === "Calc Days") {
          this.setState({
            calc_days: val.Value,
            calc_days_dbfield: val.DBField,
            calc_days_validate: val.Validate,
            calc_days_hide: val.Hide === 1 ? "checked" : "",
            calc_days_readonly: val.Readonly === 1 ? "checked" : "",
            calc_days_required: val.Required === 1 ? "checked" : "",
            calc_days_length: val.Length,
            calc_days_script: val.Script,
            calc_days_tag: val.Tag,
            calc_days_type: val.Type,
            calc_days_order: val.Order,
          });
        }
        if (val.Desc === "Calc Weeks") {
          this.setState({
            calc_weeks: val.Value,
            calc_weeks_dbfield: val.DBField,
            calc_weeks_validate: val.Validate,
            calc_weeks_hide: val.Hide === 1 ? "checked" : "",
            calc_weeks_readonly: val.Readonly === 1 ? "checked" : "",
            calc_weeks_required: val.Required === 1 ? "checked" : "",
            calc_weeks_length: val.Length,
            calc_weeks_script: val.Script,
            calc_weeks_tag: val.Tag,
            calc_weeks_type: val.Type,
            calc_weeks_order: val.Order,
          });
        }
        return null;
      });
      this.state.listHandler.CustomFields.map((field,index)=>
      {

        if (field.Desc === "Units") {
          field.Order = this.state.unit_order;
          field.Hide = this.state.unit_hide;
        }
        if (field.Desc === "Unit Desc") {
          field.Order = this.state.unit_desc_order;
          field.Hide = this.state.unit_desc_hide;
        }
        if (field.Desc === "Rate") {
          field.Order = this.state.rate_order;
          field.Hide = this.state.rate_hide;
        }
        if (field.Desc === "Factor") {
          field.Order = this.state.factor_order;
          field.Hide = this.state.factor_hide;
        }
    
        if (field.Desc === "Amount") {
          field.Order = this.state.amount_order;
          field.Hide = this.state.amount_hide;
        }
    
        if (field.Desc === "Capped Amount") {
          field.Order = this.state.capped_amount_order;
          field.Hide = this.state.capped_amount_hide;
        }
    
        if (field.Desc === "Date From:") {
          field.Order =this.state.startDate_order;
          field.Hide = this.state.startDate_hide;
        }
    
        if (field.Desc === "Date To:") {
          field.Order = this.state.endDate_order;
          field.Hide = this.state.endDate_hide;
        }
    
        if (field.Desc === "Chart Sort") {
          field.Order = this.state.chart_sort_order;
          field.Hide = this.state.chart_sort_hide;
        }
        if (field.Desc === "Chart Code") {
          field.Order = this.state.chart_code_order;
          field.Hide = this.state.chart_code_hide;
        }
        if (field.Desc === "Flag:") {
          field.Order = this.state.flag_order;
          field.Hide = this.state.flag_hide;
        }
        if (field.Desc === "Payment Flag:") {
          field.Order = this.state.payment_flag_order;
          field.Hide = this.state.payment_flag_hide;
        }
        if (field.Desc === "Calc Days") {
          field.Order = this.state.calc_days_order
          field.Hide =this.state.calc_days_hide;
        }
        if (field.Desc === "Calc Weeks") {
          field.Order = this.state.calc_weeks_order;
          field.Hide = this.state.calc_weeks_hide;
        }
        if (field.Desc === "Days in Week") {
          field.Order = this.state.days_in_week_order;
          field.Hide = this.state.days_in_week_hide;
        }        
      })
      this.setState({
        isLoading: false,
        actionsubmission: "updated",
      });
      this.onad_ModalOpen();
    }
  };

 
  onad_ModalClose = async () => {
      this.setState({ ad_modalOpen: false });
    if (this.state.upadteableid !== "") {
      
      await this.setState({
        recordupdating: "",
        upadteableid: "",
        updateabledata: "",
  
      });
    }

  this.state.listHandler.CustomFields.map((field, i) => {
    if (field.Desc === "Units") {
      field.Order = 1;
      field.Hide = null;
    }
    if (field.Desc === "Unit Desc") {
      field.Order = 2;
      field.Hide = null;
    }
    if (field.Desc === "Rate") {
      field.Order = 3;
      field.Hide = null;
    }
    if (field.Desc === "Factor") {
      field.Order = 4;
      field.Hide = null;
    }

    if (field.Desc === "Amount") {
      field.Order = 5;
      field.Hide = null;
    }

    if (field.Desc === "Capped Amount") {
      field.Order = 6;
      field.Hide = null;
    }

    if (field.Desc === "Date From:") {
      field.Order = 7;
      field.Hide = null;
    }

    if (field.Desc === "Date To:") {
      field.Order = 8;
      field.Hide = null;
    }

    if (field.Desc === "Chart Sort") {
      field.Order = 9;
      field.Hide = null;
    }
    if (field.Desc === "Chart Code") {
      field.Order = 10;
      field.Hide = null;
    }
    if (field.Desc === "Flag:") {
      field.Order = 11;
      field.Hide = null;
    }
    if (field.Desc === "Payment Flag:") {
      field.Order = 12;
      field.Hide = null;
    }
    if (field.Desc === "Calc Days") {
      field.Order = 13;
      field.Hide = null;
    }
    if (field.Desc === "Calc Weeks") {
      field.Order = 14;
      field.Hide = null;
    }
    if (field.Desc === "Days in Week") {
      field.Order = 15;
      field.Hide = null;
    }
  });


    await this.setState({
      tagsFormHtml: "",
      modalOpen: false,
      ad_modalOpen: false,
      deletestatus: false,
      UnitDescModalOpen: false,
      RateModalOpen: false,
      FactorModalOpen: false,
      AmountModalOpen: false,
      DaysInWeekdModalOpen: false,
      CappedModalOpen: false,
      DateFromModalOpen: false,
      DateToModalOpen: false,
      ChartModalOpen: false,
      ChartCodeModalOpen: false,
      FlagModalOpen: false,
      PaymentFlagModalOpen: false,
      CalcDaysModalOpen: false,
      CalcWeeksModalOpen: false,
      setupModalOpen: false,
      setupTrackingFieldEditModal: false,
      pmt_code: "",
      desc: "",
      TBA: null,
      unit: 0,
      unit_dbfield: null,
      unit_validate: null,
      unit_hide: null,
      unit_readonly: null,
      unit_required: null,
      unit_length: null,
      unit_script: null,
      unit_tag: null,
      unit_type: null,
      unit_order: 1,
      unit_desc: null,
      unit_desc_dbfield: null,
      unit_desc_validate: null,
      unit_desc_hide: null,
      unit_desc_readonly: null,
      unit_desc_required: null,
      unit_desc_length: null,
      unit_desc_script: null,
      unit_desc_tag: null,
      unit_desc_type: null,
      unit_desc_order: 2,
      rate: 0,
      rate_dbfield: null,
      rate_validate: null,
      rate_hide: null,
      rate_readonly: null,
      rate_required: null,
      rate_length: null,
      rate_script: null,
      rate_tag: null,
      rate_type: null,
      rate_order: 3,
      factor: 0,
      factor_dbfield: null,
      factor_validate: null,
      factor_hide: null,
      factor_readonly: null,
      factor_required: null,
      factor_length: null,
      factor_script: null,
      factor_tag: null,
      factor_type: null,
      factor_order: 4,
      amount: 0,
      amount_dbfield: null,
      amount_validate: null,
      amount_hide: null,
      amount_readonly: null,
      amount_required: null,
      amount_length: null,
      amount_script: null,
      amount_tag: null,
      amount_type: null,
      amount_order: 5,
      capped_amount: null,
      capped_amount_dbfield: null,
      capped_amount_validate: null,
      capped_amount_hide: null,
      capped_amount_readonly: null,
      capped_amount_required: null,
      capped_amount_length: null,
      capped_amount_script: null,
      capped_amount_tag: null,
      capped_amount_type: null,
      capped_amount_order: 6,
      days_in_week: null,
      days_in_week_dbfield: null,
      days_in_week_validate: null,
      days_in_week_hide: null,
      days_in_week_readonly: null,
      days_in_week_required: null,
      days_in_week_length: null,
      days_in_week_script: null,
      days_in_week_tag: null,
      days_in_week_type: null,
      days_in_week_order: 7,
      startDate: moment(),
      startDate_dbfield: null,
      startDate_validate: null,
      startDate_hide: null,
      startDate_readonly: null,
      startDate_required: null,
      startDate_length: null,
      startDate_script: null,
      startDate_tag: null,
      startDate_type: null,
      startDate_order: 8,
      endDate: moment().add(1, "days"),
      endDate_dbfield: null,
      endDate_validate: null,
      endDate_hide: null,
      endDate_readonly: null,
      endDate_required: null,
      endDate_length: null,
      endDate_script: null,
      endDate_tag: null,
      endDate_type: null,
      endDate_order: 9,
      chart_sort: null,
      chart_sort_dbfield: null,
      chart_sort_validate: null,
      chart_sort_hide: null,
      chart_sort_readonly: null,
      chart_sort_required: null,
      chart_sort_length: null,
      chart_sort_script: null,
      chart_sort_tag: null,
      chart_sort_type: null,
      chart_sort_order: 10,
      chart_code: null,
      chart_code_dbfield: null,
      chart_code_validate: null,
      chart_code_hide: null,
      chart_code_readonly: null,
      chart_code_required: null,
      chart_code_length: null,
      chart_code_script: null,
      chart_code_tag: null,
      chart_code_type: null,
      chart_code_order: 11,
      flag: null,
      flag_dbfield: null,
      flag_validate: null,
      flag_hide: null,
      flag_readonly: null,
      flag_required: null,
      flag_length: null,
      flag_script: null,
      flag_tag: null,
      flag_type: null,
      flag_order: 12,
      payment_flag: null,
      payment_flag_dbfield: null,
      payment_flag_validate: null,
      payment_flag_hide: null,
      payment_flag_readonly: null,
      payment_flag_required: null,
      payment_flag_length: null,
      payment_flag_script: null,
      payment_flag_tag: null,
      payment_flag_type: null,
      payment_flag_order: 13,
      calc_days: null,
      calc_days_dbfield: null,
      calc_days_validate: null,
      calc_days_hide: null,
      calc_days_readonly: null,
      calc_days_required: null,
      calc_days_length: null,
      calc_days_script: null,
      calc_days_tag: null,
      calc_days_type: null,
      calc_days_order: 14,
      calc_weeks: null,
      calc_weeks_dbfield: null,
      calc_weeks_validate: null,
      calc_weeks_hide: null,
      calc_weeks_readonly: null,
      calc_weeks_required: null,
      calc_weeks_length: null,
      calc_weeks_script: null,
      calc_weeks_tag: null,
      calc_weeks_type: null,
      calc_weeks_order: 15,
      formErrors: {
        pmt_code: "",
        desc: "",
        unit: "",
        unit_desc: "",
        rate: "",
        factor: "",
        amount: "",
        capped_amount: "",
        days_in_week: "",
        chart_sort: "",
        chart_code: "",
        flag: "",
        payment_flag: "",
      },
      chart_sortValid: "",
      payment_flagValid: "",
      flagValid: "",
      PmtCodeValid: "",
      unit_descValid: "",
      descValid: "",
      days_in_weekValid: "",
      unitValid: "",
      rateValid: "",
      amountValid: "",
      chart_codeValid: "",
      capped_amountValid: "",
      factorValid: "",
      formValid: "",
      isActive: "",
    });


  };
  onad_ModalOpen() {
    this.state.listHandler.CustomFields.sort((a, b) =>
      a.Order > b.Order ? 1 : -1
    );

    this.setState({ ad_modalOpen: true });
    var thisobj = this;
    setTimeout(function () {
      if (thisobj.state.amount === 0) {
        thisobj.setState({ datePickerDisable: true });
      } else {
        thisobj.setState({ datePickerDisable: false });
      }
      if (thisobj.state.recordupdating) {
        if (thisobj.state.TBA === "checked") {
          thisobj.setState({ calc_days: 0, calc_weeks: 0 });
        } else {
          var startDate = moment(thisobj.state.startDate.format("YYYY-MM-DD"));
          var endDate = moment(thisobj.state.endDate.format("YYYY-MM-DD"));
          if (startDate.isSameOrBefore(endDate)) {
            var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
            var calc_weeks = endDate.diff(startDate, "days");

            if (calc_days >= thisobj.state.days_in_week) {
              calc_weeks++;
              thisobj.setState({
                calc_days: 0,
                calc_weeks: calc_weeks,
              });
            } else {
              if (calc_days === 0) {
                calc_days++;
              }
              thisobj.setState({
                calc_days: Math.floor(calc_days),
                calc_weeks: Math.floor(calc_weeks),
              });
            }
          } else {
            thisobj.setState({
              calc_days: 0,
              calc_weeks: 0,
            });
          }
          if (endDate.isSameOrAfter(startDate)) {
            var duration = moment.duration(
              thisobj.state.endDate.diff(thisobj.state.startDate)
            );
            var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
            var calc_weeks = endDate.diff(startDate, "weeks");
            if (calc_days >= thisobj.state.days_in_week) {
              calc_weeks++;
              thisobj.setState({
                calc_days: 0,
                calc_weeks: calc_weeks,
              });
            } else {
              if (Math.floor(calc_days) === 0) {
                calc_weeks++;
              }
              thisobj.setState({
                calc_days: calc_days,
                calc_weeks: calc_weeks,
              });
            }
          } else {
            thisobj.setState({
              calc_days: 0,
              calc_weeks: 0,
            });
          }
        }
      }

      var tagsFormHtml = $("#tagsForm");
      thisobj.setState({ tagsFormHtml: tagsFormHtml });
    }, 70);
  }
  onModal_Save=(event)=>
  {
    if (event.target.id === "unitModal") {
      if (this.state.unit_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ modalOpen: false });
    }
    if (event.target.id === "unitDescModal") {
      if (this.state.unit_desc_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ UnitDescModalOpen: false });
    }
    if (event.target.id === "rate_Modal") {
      if (this.state.rate_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ RateModalOpen: false });
    }
    if (event.target.id === "factor_Modal") {
      if (this.state.factor_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ FactorModalOpen: false });
    }
    if (event.target.id === "amount_Modal") {
      if (this.state.amount_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ AmountModalOpen: false });
    }
    if (event.target.id === "capped_Modal") {
      if (this.state.capped_amount_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ CappedModalOpen: false });
    }
    if (event.target.id === "chartS_Modal") {
      if (this.state.chart_sort_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ ChartModalOpen: false });
    }
    if (event.target.id === "chartC_Modal") {
      if (this.state.chart_code_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ ChartCodeModalOpen: false });
    }
    if (event.target.id === "days_Modal") {
      if (this.state.days_in_week_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ DaysInWeekdModalOpen: false });
    }
    if (event.target.id === "startDate_Modal") {
      if (this.state.startDate_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ DateFromModalOpen: false });
    }
    if (event.target.id === "endDate_Modal") {
      if (this.state.endDate_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ DateToModalOpen: false });
    }
    if (event.target.id === "flag_Modal") {
      if (this.state.flag_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ FlagModalOpen: false });
    }
    if (event.target.id === "payment_Modal") {
      if (this.state.payment_flag_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ PaymentFlagModalOpen: false });
    }
    if (event.target.id === "calcD_Modal") {
      if (this.state.calc_days_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ CalcDaysModalOpen: false });
    }
    if (event.target.id === "calcW_Modal") {
      if (this.state.calc_weeks_hide) {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 1;
          }
        });
      } else {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 0;
          }
        });
      }
      this.setState({ CalcWeeksModalOpen: false });
    }
  }

  onUnitModalClose() {
    if (this.state.unitC_hide) {
      this.setState({ unit_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Units") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ unit_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Units") {
          obj.Hide = 0;
        }
      });
    }
    this.setState({ modalOpen: false });
  }
  onUnitModalOpen() {
    if (this.state.unit_hide) {
      this.setState({ unitC_hide: true });
    } else {
      this.setState({ unitC_hide: false });
    }
    this.setState({ modalOpen: true });
  }
  onUnitDescModalOpen() {
    if (this.state.unit_desc_hide) {
      this.setState({ unitC_desc_hide: true });
    } else {
      this.setState({ unitC_desc_hide: false });
    }
    this.setState({ UnitDescModalOpen: true });
  }
  onUnitDescModalClose() {
    if (this.state.unitC_desc_hide) {
      this.setState({ unit_desc_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Unit Desc") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ unit_desc_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Unit Desc") {
          obj.Hide = 0;
        }
      });
    }
    this.setState({ UnitDescModalOpen: false });
  }
  onRateModalOpen() {
    if (this.state.rate_hide) {
      this.setState({ rateC_hide: true });
    } else {
      this.setState({ rateC_hide: false });
    }
    this.setState({ RateModalOpen: true });
  }
  onRateModalClose() {
    if (this.state.rateC_hide) {
      this.setState({ rate_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Rate") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ rate_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Rate") {
          obj.Hide = 0;
        }
      });
    }
    this.setState({ RateModalOpen: false });
  }
  onFactorModalOpen() {
    if (this.state.factor_hide) {
      this.setState({ factorC_hide: true });
    } else {
      this.setState({ factorC_hide: false });
    }
    this.setState({ FactorModalOpen: true });
  }
  onFactorModalClose() {
    if (this.state.factorC_hide) {
      this.setState({ factor_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Factor") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ factor_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Factor") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ FactorModalOpen: false });
  }
  onAmountModalOpen() {
    if (this.state.amount_hide) {
      this.setState({ amountC_hide: true });
    } else {
      this.setState({ amountC_hide: false });
    }

    this.setState({ AmountModalOpen: true });
  }
  onAmountModalClose() {
    if (this.state.amountC_hide) {
      this.setState({ amount_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Amount") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ amount_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Amount") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ AmountModalOpen: false });
  }
  onCappedModalOpen() {
    if (this.state.capped_amount_hide) {
      this.setState({ cappedC_amount_hide: true });
    } else {
      this.setState({ cappedC_amount_hide: false });
    }

    this.setState({ CappedModalOpen: true });
  }
  onCappedModalClose() {
    if (this.state.cappedC_amount_hide) {
      this.setState({ capped_amount_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Capped Amount") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ capped_amount_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Capped Amount") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ CappedModalOpen: false });
  }
  onDaysInWeekModalOpen() {
    if (this.state.days_in_week_hide) {
      this.setState({ daysC_in_week_hide: true });
    } else {
      this.setState({ daysC_in_week_hide: false });
    }

    this.setState({ DaysInWeekdModalOpen: true });
  }
  onDaysInWeekModalClose() {
    if (this.state.daysC_in_week_hide) {
      this.setState({ days_in_week_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Days in Week") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ days_in_week_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Days in Week") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ DaysInWeekdModalOpen: false });
  }
  onDateFromModalOpen() {
    if (this.state.startDate_hide) {
      this.setState({ startDateC_hide: true });
    } else {
      this.setState({ startDateC_hide: false });
    }
 
    this.setState({ DateFromModalOpen: true });
  }
  onDateFromModalClose() {
    if (this.state.startDateC_hide) {
      this.setState({ startDate_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Date From:") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ startDate_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Date From:") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ DateFromModalOpen: false });
  }
  onDateToModalOpen() {
    if (this.state.endDate_hide) {
      this.setState({ endDateC_hide: true });
    } else {
      this.setState({ endDateC_hide: false });
    }

    this.setState({ DateToModalOpen: true });
  }
  onDateToModalClose() {
    if (this.state.endDateC_hide) {
      this.setState({ endDate_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Date To:") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ endDate_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Date To:") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ DateToModalOpen: false });
  }
  onChartModalOpen() {
    if (this.state.chart_sort_hide) {
      this.setState({ chartC_sort_hide: true });
    } else {
      this.setState({ chartC_sort_hide: false });
    }

    this.setState({ ChartModalOpen: true });
  }
  onChartModalClose() {
    if (this.state.chartC_sort_hide) {
      this.setState({ chart_sort_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Chart Sort") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ chart_sort_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Chart Sort") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ ChartModalOpen: false });
  }
  onChartCodeModalOpen() {
    if (this.state.chart_code_hide) {
      this.setState({ chartC_code_hide: true });
    } else {
      this.setState({ chartC_code_hide: false });
    }

    this.setState({ ChartCodeModalOpen: true });
  }
  onChartCodeModalClose() {
    if (this.state.chartC_code_hide) {
      this.setState({ chart_code_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Chart Code") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ chart_code_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Chart Code") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ ChartCodeModalOpen: false });
  }
  onFlagModalOpen() {
    if (this.state.flag_hide) {
      this.setState({ flagC_hide: true });
    } else {
      this.setState({ flagC_hide: false });
    }

    this.setState({ FlagModalOpen: true });
  }
  onFlagModalClose() {
    if (this.state.flagC_hide) {
      this.setState({ flag_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Flag:") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ flag_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Flag:") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ FlagModalOpen: false });
  }
  onPaymentFlagModalOpen() {
    if (this.state.payment_flag_hide) {
      this.setState({ paymentC_flag_hide: true });
    } else {
      this.setState({ paymentC_flag_hide: false });
    }
    this.setState({ PaymentFlagModalOpen: true });
  }
  onPaymentFlagModalClose() {
    if (this.state.paymentC_flag_hide) {
      this.setState({ payment_flag_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Payment Flag:") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ payment_flag_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Payment Flag:") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ PaymentFlagModalOpen: false });
  }
  onCalcDaysModalClose() {
    if (this.state.calcC_days_hide) {
      this.setState({ calc_days_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Calc Days") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ calc_days_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Calc Days") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ CalcDaysModalOpen: false });
  }
  onCalcDaysModalOpen() {
    if (this.state.calc_days_hide) {
      this.setState({ calcC_days_hide: true });
    } else {
      this.setState({ calcC_days_hide: false });
    }
    this.setState({ CalcDaysModalOpen: true });
  }
  onCalcWeeksModalClose() {
    if (this.state.calcC_weeks_hide) {
      this.setState({ calc_weeks_hide: "checked" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Calc Weeks") {
          obj.Hide = 1;
        }
      });
    } else {
      this.setState({ calc_weeks_hide: "" });
      this.state.listHandler.CustomFields.map((obj, i) => {
        if (obj.Desc === "Calc Weeks") {
          obj.Hide = 0;
        }
      });
    }

    this.setState({ CalcWeeksModalOpen: false });
  }
  onCalcWeeksModalOpen() {
    if (this.state.calc_weeks_hide) {
      this.setState({ calcC_weeks_hide: true });
    } else {
      this.setState({ calcC_weeks_hide: false });
    }

    this.setState({ CalcWeeksModalOpen: true });
  }


  handleChange(date) {
    let startDate = moment(date.format("YYYY-MM-DD"));
    let endDate = moment(this.state.endDate.format("YYYY-MM-DD"));

    if (startDate.isSameOrBefore(this.state.endDate.format("YYYY-MM-DD"))) {
      this.setState({
        startDate: date,
      });
      var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
      var calc_weeks = endDate.diff(startDate, "weeks");

      if (calc_days >= this.state.days_in_week) {
        calc_weeks++;
        this.setState({
          calc_days: 0,
          calc_weeks: calc_weeks,
        });
      } else {
        if (calc_days === 0) {
          calc_weeks++;
        }
        this.setState({
          calc_days: calc_days,
          calc_weeks: calc_weeks,
        });
      }
    } else {
      this.setState({
        startDate: date,
        calc_weeks: 0,
        calc_days: 0,
      });
    }
  }

  handleChangeTo(date) {
    let startDate = moment(this.state.startDate.format("YYYY-MM-DD"));
    let endDate = moment(date.format("YYYY-MM-DD"));

    if (endDate.isSameOrAfter(startDate)) {
      this.setState({
        endDate: date,
      });
      var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
      var calc_weeks = endDate.diff(startDate, "weeks");
      if (calc_days >= this.state.days_in_week) {
        calc_weeks++;
        this.setState({
          calc_days: 0,
          calc_weeks: calc_weeks,
        });
      } else {
        if (calc_days === 0) {
          calc_weeks++;
        }
        this.setState({
          calc_days: calc_days,
          calc_weeks: calc_weeks,
        });
      }
    } else {
      this.setState({
        endDate: date,
        calc_days: 0,
        calc_weeks: 0,
      });
    }
  }
  showDateFrom() {
    document.getElementById("showDateFrom").click();
  }
  showDateTo() {
    document.getElementById("showDateTo").click();
  }


  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let PmtCodeValid = this.state.PmtCodeValid;
    let descValid = this.state.descValid;
    switch (fieldName) {
      case "pmt_code":
        PmtCodeValid = value.length > 0;
        fieldValidationErrors.pmt_code = PmtCodeValid
          ? ""
          : "This field is required";
        break;
      case "desc":
        descValid = value.length > 0;
        fieldValidationErrors.desc = descValid ? "" : "This field is required";
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        PmtCodeValid: PmtCodeValid,
      },
      this.validateForm
    );
  }
  validateForm() {
    this.setState({
      formValid: this.state.pmt_code && this.state.desc,
      isActive: this.state.pmt_code && this.state.desc,
    });
  }
  handleUserInputCheckbox(event) {
    let name = event.target.name;
    var value = event.target.value;

    if (value === "" || value === null) {
      this.setState({
        [name]: "checked",
      });
      if (name === "TBA") {
        this.setState({ calc_days: 0, calc_weeks: 0 });
      }
      if (name === "unit_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 1;
          }
        });
      }
      if (name === "unit_desc_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "rate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "factor_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "amount_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "capped_amount_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 1;
          }
        });
      }
      if (name === "days_in_week_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "startDate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "endDate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "chart_sort_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 1;
          }
        });
      }
      if (name === "chart_code_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "flag_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "payment_flag_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 1;
          }
        });
      }

      if (name === "calc_days_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 1;
          }
        });
      }
      if (name === "calc_weeks_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 1;
          }
        });
      }
    } else {
      this.setState({
        [name]: "",
      });
      if (name === "TBA") {
        if (this.state.datePickerDisable) {
          this.setState({ calc_days: 0, calc_weeks: 0 });
        } else {
          this.handleChangeTo(this.state.endDate);
        }
      }

      if (name === "unit_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Units") {
            obj.Hide = 0;
          }
        });
      }
      if (name === "unit_desc_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Unit Desc") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "rate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Rate") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "factor_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Factor") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "amount_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Amount") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "capped_amount_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Capped Amount") {
            obj.Hide = 0;
          }
        });
      }
      if (name === "days_in_week_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Days in Week") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "startDate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date From:") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "endDate_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Date To:") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "chart_sort_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Sort") {
            obj.Hide = 0;
          }
        });
      }
      if (name === "chart_code_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Chart Code") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "flag_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Flag:") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "payment_flag_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Payment Flag:") {
            obj.Hide = 0;
          }
        });
      }

      if (name === "calc_days_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Days") {
            obj.Hide = 0;
          }
        });
      }
      if (name === "calc_weeks_hide") {
        this.state.listHandler.CustomFields.map((obj, i) => {
          if (obj.Desc === "Calc Weeks") {
            obj.Hide = 0;
          }
        });
      }
    }
  }
  /*handleUserInput(event) {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({
                [name]: value
            },
            () => {
                this.validateField(name, value)
            });
    }*/
  handleUserInput = async (event) => {
    let name = event.target.name;
    let value = event.target.value ? event.target.value : "";

    let factor = this.state.factor;
    let rate = this.state.rate;
    let unit = this.state.unit;

    if (name === "factor") {
      //console.log('factor name');
      this.amount_calculation((factor = value), rate, unit);
    } else if (name === "rate") {
      //console.log('rate name');
      this.amount_calculation(factor, (rate = value), unit);
    } else if (name === "unit") {
      this.amount_calculation(factor, rate, (unit = value));
    }

    await this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      }
    );

    if (name === "days_in_week") {
      if (moment(this.state.startDate).isBefore(this.state.endDate)) {
        var duration = moment.duration(
          this.state.endDate.diff(this.state.startDate)
        );
        var calc_days = (duration.asDays() + 1) % 7;
        var calc_weeks = duration.asWeeks();
        //console.log("Calculation days => ", calc_days);
        //console.log("Calculation weeks => ", calc_weeks);
        if (Math.round(calc_days) >= this.state.days_in_week) {
          //console.log("cal days => " , this.state.days_in_week);
          calc_weeks++;
          this.setState({
            calc_days: 0,
            calc_weeks: Math.floor(calc_weeks),
          });
        } else {
          if (calc_days === 0) {
            calc_weeks++;
          }
          this.setState({
            calc_days: Math.floor(calc_days),
            calc_weeks: Math.floor(calc_weeks),
          });
        }
      } else {
        //alert('Please Select date before '+ moment.utc(this.state.endDate).format('LL') +'');
      }
    }
  };

  amount_calculation = (factor, rate, unit) => {
    let amount = 0;
    console.log("factor=> ", factor);
    console.log("rate=> ", rate);
    console.log("unit=> ", unit);
    amount = factor * rate * unit;
    this.setState(
      {
        amount: amount,
        handlechangeamount: amount,
      },
      () => {
        if (this.state.amount === 0) {
          this.setState({
            datePickerDisable: true,
          });
        } else {
          this.setState({ datePickerDisable: false });
          this.handleChangeTo(this.state.endDate);
        }
      }
    );
  };

  insertCustomFieldsList(
    upadteableid,
    pmt_code,
    desc,
    TBA,
    unit,
    unit_dbfield,
    unit_validate,
    unit_hide,
    unit_readonly,
    unit_required,
    unit_length,
    unit_script,
    unit_tag,
    unit_type,
    unit_order,
    unit_desc,
    unit_desc_dbfield,
    unit_desc_validate,
    unit_desc_hide,
    unit_desc_readonly,
    unit_desc_required,
    unit_desc_length,
    unit_desc_desc_script,
    unit_desc_desc_tag,
    unit_desc_desc_type,
    unit_desc_order,
    rate,
    rate_dbfield,
    rate_validate,
    rate_hide,
    rate_readonly,
    rate_required,
    rate_length,
    rate_script,
    rate_tag,
    rate_type,
    rate_order,
    factor,
    factor_dbfield,
    factor_validate,
    factor_hide,
    factor_readonly,
    factor_required,
    factor_length,
    factor_script,
    factor_tag,
    factor_type,
    factor_order,
    amount,
    amount_dbfield,
    amount_validate,
    amount_hide,
    amount_readonly,
    amount_required,
    amount_length,
    amount_script,
    amount_tag,
    amount_type,
    amount_order,
    capped_amount,
    capped_amount_dbfield,
    capped_amount_validate,
    capped_amount_hide,
    capped_amount_readonly,
    capped_amount_required,
    capped_amount_length,
    capped_amount_script,
    capped_amount_tag,
    capped_amount_type,
    capped_amount_order,
    days_in_week,
    days_in_week_dbfield,
    days_in_week_validate,
    days_in_week_hide,
    days_in_week_readonly,
    days_in_week_required,
    days_in_week_length,
    days_in_week_script,
    days_in_week_tag,
    days_in_week_type,
    days_in_week_order,
    startDate,
    startDate_dbfield,
    startDate_validate,
    startDate_hide,
    startDate_readonly,
    startDate_required,
    startDate_length,
    startDate_script,
    startDate_tag,
    startDate_type,
    startDate_order,
    endDate,
    endDate_dbfield,
    endDate_validate,
    endDate_hide,
    endDate_readonly,
    endDate_required,
    endDate_length,
    endDate_script,
    endDate_tag,
    endDate_type,
    endDate_order,
    chart_sort,
    chart_sort_dbfield,
    chart_sort_validate,
    chart_sort_hide,
    chart_sort_readonly,
    chart_sort_required,
    chart_sort_length,
    chart_sort_script,
    chart_sort_tag,
    chart_sort_type,
    chart_sort_order,
    chart_code,
    chart_code_dbfield,
    chart_code_validate,
    chart_code_hide,
    chart_code_readonly,
    chart_code_required,
    chart_code_length,
    chart_code_script,
    chart_code_tag,
    chart_code_type,
    chart_code_order,
    flag,
    flag_dbfield,
    flag_validate,
    flag_hide,
    flag_readonly,
    flag_required,
    flag_length,
    flag_script,
    flag_tag,
    flag_type,
    flag_order,
    payment_flag,
    payment_flag_dbfield,
    payment_flag_validate,
    payment_flag_hide,
    payment_flag_readonly,
    payment_flag_required,
    payment_flag_length,
    payment_flag_script,
    payment_flag_tag,
    payment_flag_type,
    payment_flag_order,
    calc_days,
    calc_days_dbfield,
    calc_days_validate,
    calc_days_hide,
    calc_days_readonly,
    calc_days_required,
    calc_days_length,
    calc_days_script,
    calc_days_tag,
    calc_days_type,
    calc_days_order,
    calc_weeks,
    calc_weeks_dbfield,
    calc_weeks_validate,
    calc_weeks_hide,
    calc_weeks_readonly,
    calc_weeks_required,
    calc_weeks_length,
    calc_weeks_script,
    calc_weeks_tag,
    calc_weeks_type,
    calc_weeks_order
  ) {
    console.log("ORDERRRRR", days_in_week_order);
    if (unit_hide === 1) {
      unit_hide = "checked";
    }
    if (unit_readonly === 1) {
      unit_readonly = "checked";
    }
    if (unit_required === 1) {
      unit_required = "checked";
    }
    if (unit_desc_hide === 1) {
      unit_desc_hide = "checked";
    }
    if (unit_desc_readonly === 1) {
      unit_desc_readonly = "checked";
    }
    if (unit_desc_required === 1) {
      unit_desc_required = "checked";
    }

    if (rate_hide === 1) {
      rate_hide = "checked";
    }
    if (rate_readonly === 1) {
      rate_readonly = "checked";
    }
    if (rate_required === 1) {
      rate_required = "checked";
    }

    if (factor_hide === 1) {
      factor_hide = "checked";
    }
    if (factor_readonly === 1) {
      factor_readonly = "checked";
    }
    if (factor_required === 1) {
      factor_required = "checked";
    }

    if (amount_hide === 1) {
      amount_hide = "checked";
    }
    if (amount_readonly === 1) {
      amount_readonly = "checked";
    }
    if (amount_required === 1) {
      amount_required = "checked";
    }

    if (capped_amount_hide === 1) {
      capped_amount_hide = "checked";
    }
    if (capped_amount_readonly === 1) {
      capped_amount_readonly = "checked";
    }
    if (capped_amount_required === 1) {
      capped_amount_required = "checked";
    }

    if (days_in_week_hide === 1) {
      days_in_week_hide = "checked";
    }
    if (days_in_week_readonly === 1) {
      days_in_week_readonly = "checked";
    }
    if (days_in_week_required === 1) {
      days_in_week_required = "checked";
    }

    if (chart_sort_hide === 1) {
      chart_sort_hide = "checked";
    }
    if (chart_sort_readonly === 1) {
      chart_sort_readonly = "checked";
    }
    if (chart_sort_required === 1) {
      chart_sort_required = "checked";
    }

    if (chart_code_hide === 1) {
      chart_code_hide = "checked";
    }
    if (chart_code_readonly === 1) {
      chart_code_readonly = "checked";
    }
    if (chart_code_required === 1) {
      chart_code_required = "checked";
    }

    if (flag_hide === 1) {
      flag_hide = "checked";
    }
    if (flag_readonly === 1) {
      flag_readonly = "checked";
    }
    if (flag_required === 1) {
      flag_required = "checked";
    }

    if (payment_flag_hide === 1) {
      payment_flag_hide = "checked";
    }
    if (payment_flag_readonly === 1) {
      payment_flag_readonly = "checked";
    }
    if (payment_flag_required === 1) {
      payment_flag_required = "checked";
    }

    if (startDate_hide === 1) {
      startDate_hide = "checked";
    }
    if (startDate_readonly === 1) {
      startDate_readonly = "checked";
    }
    if (startDate_required === 1) {
      startDate_required = "checked";
    }

    if (endDate_hide === 1) {
      endDate_hide = "checked";
    }
    if (endDate_readonly === 1) {
      endDate_readonly = "checked";
    }
    if (endDate_required === 1) {
      endDate_required = "checked";
    }
    if (calc_days_hide === 1) {
      calc_days_hide = "checked";
    }
    if (calc_days_readonly === 1) {
      calc_days_readonly = "checked";
    }
    if (calc_days_required === 1) {
      calc_days_required = "checked";
    }

    if (calc_weeks_hide === 1) {
      calc_weeks_hide = "checked";
    }
    if (calc_weeks_readonly === 1) {
      calc_weeks_readonly = "checked";
    }
    if (calc_weeks_required === 1) {
      calc_weeks_required = "checked";
    }
    console.log("=>TBA@", TBA);
    return this.props.postRequest(
      "/custom-list-fields/create-custom-list-field",
      {
        upadteableid: upadteableid,
        pmt_code: pmt_code,
        desc: desc,
        CompanyGuid: localStorage.getItem('companyGuid'),
        TBA: TBA,
        unit: unit,
        unit_dbfield: unit_dbfield,
        unit_validate: unit_validate,
        unit_hide: unit_hide,
        unit_readonly: unit_readonly,
        unit_required: unit_required,
        unit_length: unit_length,
        unit_script: unit_script,
        unit_tag: unit_tag,
        unit_type: unit_type,
        unit_order: unit_order,
        unit_desc: unit_desc,
        unit_desc_dbfield: unit_desc_dbfield,
        unit_desc_validate: unit_desc_validate,
        unit_desc_hide: unit_desc_hide,
        unit_desc_readonly: unit_desc_readonly,
        unit_desc_required: unit_desc_required,
        unit_desc_length: unit_desc_length,
        unit_desc_script: unit_desc_desc_script,
        unit_desc_tag: unit_desc_desc_tag,
        unit_desc_type: unit_desc_desc_type,
        unit_desc_order: unit_desc_order,
        rate: rate,
        rate_dbfield: rate_dbfield,
        rate_validate: rate_validate,
        rate_hide: rate_hide,
        rate_readonly: rate_readonly,
        rate_required: rate_required,
        rate_length: rate_length,
        rate_script: rate_script,
        rate_tag: rate_tag,
        rate_type: rate_type,
        rate_order: rate_order,
        factor: factor,
        factor_dbfield: factor_dbfield,
        factor_validate: factor_validate,
        factor_hide: factor_hide,
        factor_readonly: factor_readonly,
        factor_required: factor_required,
        factor_length: factor_length,
        factor_script: factor_script,
        factor_tag: factor_tag,
        factor_type: factor_type,
        factor_order: factor_order,
        amount: amount,
        amount_dbfield: amount_dbfield,
        amount_validate: amount_validate,
        amount_hide: amount_hide,
        amount_readonly: amount_readonly,
        amount_required: amount_required,
        amount_length: amount_length,
        amount_script: amount_script,
        amount_tag: amount_tag,
        amount_type: amount_type,
        amount_order: amount_order,
        capped_amount: capped_amount,
        capped_amount_dbfield: capped_amount_dbfield,
        capped_amount_validate: capped_amount_validate,
        capped_amount_hide: capped_amount_hide,
        capped_amount_readonly: capped_amount_readonly,
        capped_amount_required: capped_amount_required,
        capped_amount_length: capped_amount_length,
        capped_amount_script: capped_amount_script,
        capped_amount_tag: capped_amount_tag,
        capped_amount_type: capped_amount_type,
        capped_amount_order: capped_amount_order,
        days_in_week: days_in_week,
        days_in_week_dbfield: days_in_week_dbfield,
        days_in_week_validate: days_in_week_validate,
        days_in_week_hide: days_in_week_hide,
        days_in_week_readonly: days_in_week_readonly,
        days_in_week_required: days_in_week_required,
        days_in_week_length: days_in_week_length,
        days_in_week_script: days_in_week_script,
        days_in_week_tag: days_in_week_tag,
        days_in_week_type: days_in_week_type,
        days_in_week_order: days_in_week_order,
        chart_sort: chart_sort,
        chart_sort_dbfield: chart_sort_dbfield,
        chart_sort_validate: chart_sort_validate,
        chart_sort_hide: chart_sort_hide,
        chart_sort_readonly: chart_sort_readonly,
        chart_sort_required: chart_sort_required,
        chart_sort_length: chart_sort_length,
        chart_sort_script: chart_sort_script,
        chart_sort_tag: chart_sort_tag,
        chart_sort_type: chart_sort_type,
        chart_sort_order: chart_sort_order,
        chart_code: chart_code,
        chart_code_dbfield: chart_code_dbfield,
        chart_code_validate: chart_code_validate,
        chart_code_hide: chart_code_hide,
        chart_code_readonly: chart_code_readonly,
        chart_code_required: chart_code_required,
        chart_code_length: chart_code_length,
        chart_code_script: chart_code_script,
        chart_code_tag: chart_code_tag,
        chart_code_type: chart_code_type,
        chart_code_order: chart_code_order,
        flag: flag,
        flag_dbfield: flag_dbfield,
        flag_validate: flag_validate,
        flag_hide: flag_hide,
        flag_readonly: flag_readonly,
        flag_required: flag_required,
        flag_length: flag_length,
        flag_script: flag_script,
        flag_tag: flag_tag,
        flag_type: flag_type,
        flag_order: flag_order,
        payment_flag: payment_flag,
        payment_flag_dbfield: payment_flag_dbfield,
        payment_flag_validate: payment_flag_validate,
        payment_flag_hide: payment_flag_hide,
        payment_flag_readonly: payment_flag_readonly,
        payment_flag_required: payment_flag_required,
        payment_flag_length: payment_flag_length,
        payment_flag_script: payment_flag_script,
        payment_flag_tag: payment_flag_tag,
        payment_flag_type: payment_flag_type,
        payment_flag_order: payment_flag_order,
        startDate: startDate,
        startDate_dbfield: startDate_dbfield,
        startDate_validate: startDate_validate,
        startDate_hide: startDate_hide,
        startDate_readonly: startDate_readonly,
        startDate_required: startDate_required,
        startDate_length: startDate_length,
        startDate_script: startDate_script,
        startDate_tag: startDate_tag,
        startDate_type: startDate_type,
        startDate_order: startDate_order,
        endDate: endDate,
        endDate_dbfield: endDate_dbfield,
        endDate_validate: endDate_validate,
        endDate_hide: endDate_hide,
        endDate_readonly: endDate_readonly,
        endDate_required: endDate_required,
        endDate_length: endDate_length,
        endDate_script: endDate_script,
        endDate_tag: endDate_tag,
        endDate_type: endDate_type,
        endDate_order: endDate_order,
        calc_days: calc_days,
        calc_days_dbfield: calc_days_dbfield,
        calc_days_validate: calc_days_validate,
        calc_days_hide: calc_days_hide,
        calc_days_readonly: calc_days_readonly,
        calc_days_required: calc_days_required,
        calc_days_length: calc_days_length,
        calc_days_script: calc_days_script,
        calc_days_tag: calc_days_tag,
        calc_days_type: calc_days_type,
        calc_days_order: calc_days_order,
        calc_weeks: calc_weeks,
        calc_weeks_dbfield: calc_weeks_dbfield,
        calc_weeks_validate: calc_weeks_validate,
        calc_weeks_hide: calc_weeks_hide,
        calc_weeks_readonly: calc_weeks_readonly,
        calc_weeks_required: calc_weeks_required,
        calc_weeks_length: calc_weeks_length,
        calc_weeks_script: calc_weeks_script,
        calc_weeks_tag: calc_weeks_tag,
        calc_weeks_type: calc_weeks_type,
        calc_weeks_order: calc_weeks_order,
      }
    );
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    let pmt_code = this.state.pmt_code;
    let desc = this.state.desc;
    let formErrors = Object.assign({}, this.state.formErrors);
    if (pmt_code === false || pmt_code === null || pmt_code === "") {
      formErrors.pmt_code = "This field is required";
    }
    if (desc === false || desc === null || desc === "") {
      formErrors.desc = "This field is required";
      $("#addCustomFieldlistmodal .modal-body").scrollTop(0);
    }
    if (pmt_code === false || pmt_code === null || pmt_code === "") {
      formErrors.pmt_code = "This field is required";
      $("#addCustomFieldlistmodal .modal-body").scrollTop(0);
    }
    this.setState({ formErrors });
    if (this.state.pmt_code && this.state.desc) {
      this.setState({
        isLoading: true,
      });
      try {
        this.onad_ModalClose();
        const response = await this.insertCustomFieldsList(
          this.state.upadteableid,
          this.state.pmt_code,
          this.state.desc,
          this.state.TBA,
          this.state.unit,
          this.state.unit_dbfield,
          this.state.unit_validate,
          this.state.unit_hide,
          this.state.unit_readonly,
          this.state.unit_required,
          this.state.unit_length,
          this.state.unit_script,
          this.state.unit_tag,
          this.state.unit_type,
          this.state.unit_order,
          this.state.unit_desc,
          this.state.unit_desc_dbfield,
          this.state.unit_desc_validate,
          this.state.unit_desc_hide,
          this.state.unit_desc_readonly,
          this.state.unit_desc_required,
          this.state.unit_desc_length,
          this.state.unit_desc_script,
          this.state.unit_desc_tag,
          this.state.unit_desc_type,
          this.state.unit_desc_order,
          this.state.rate,
          this.state.rate_dbfield,
          this.state.rate_validate,
          this.state.rate_hide,
          this.state.rate_readonly,
          this.state.rate_required,
          this.state.rate_length,
          this.state.rate_script,
          this.state.rate_tag,
          this.state.rate_type,
          this.state.rate_order,
          this.state.factor,
          this.state.factor_dbfield,
          this.state.factor_validate,
          this.state.factor_hide,
          this.state.factor_readonly,
          this.state.factor_required,
          this.state.factor_length,
          this.state.factor_script,
          this.state.factor_tag,
          this.state.factor_type,
          this.state.factor_order,
          this.state.amount,
          this.state.amount_dbfield,
          this.state.amount_validate,
          this.state.amount_hide,
          this.state.amount_readonly,
          this.state.amount_required,
          this.state.amount_length,
          this.state.amount_script,
          this.state.amount_tag,
          this.state.amount_type,
          this.state.amount_order,
          this.state.capped_amount,
          this.state.capped_amount_dbfield,
          this.state.capped_amount_validate,
          this.state.capped_amount_hide,
          this.state.capped_amount_readonly,
          this.state.capped_amount_required,
          this.state.capped_amount_length,
          this.state.capped_amount_script,
          this.state.capped_amount_tag,
          this.state.capped_amount_type,
          this.state.capped_amount_order,
          this.state.days_in_week,
          this.state.days_in_week_dbfield,
          this.state.days_in_week_validate,
          this.state.days_in_week_hide,
          this.state.days_in_week_readonly,
          this.state.days_in_week_required,
          this.state.days_in_week_length,
          this.state.days_in_week_script,
          this.state.days_in_week_tag,
          this.state.days_in_week_type,
          this.state.days_in_week_order,
          moment.tz(this.state.startDate, "Australia/Canberra").format(),
          this.state.startDate_dbfield,
          this.state.startDate_validate,
          this.state.startDate_hide,
          this.state.startDate_readonly,
          this.state.startDate_required,
          this.state.startDate_length,
          this.state.startDate_script,
          this.state.startDate_tag,
          this.state.startDate_type,
          this.state.startDate_order,
          moment.tz(this.state.endDate, "Australia/Canberra").format(),
          this.state.endDate_dbfield,
          this.state.endDate_validate,
          this.state.endDate_hide,
          this.state.endDate_readonly,
          this.state.endDate_required,
          this.state.endDate_length,
          this.state.endDate_script,
          this.state.endDate_tag,
          this.state.endDate_type,
          this.state.endDate_order,
          this.state.chart_sort,
          this.state.chart_sort_dbfield,
          this.state.chart_sort_validate,
          this.state.chart_sort_hide,
          this.state.chart_sort_readonly,
          this.state.chart_sort_required,
          this.state.chart_sort_length,
          this.state.chart_sort_script,
          this.state.chart_sort_tag,
          this.state.chart_sort_type,
          this.state.chart_sort_order,
          this.state.chart_code,
          this.state.chart_code_dbfield,
          this.state.chart_code_validate,
          this.state.chart_code_hide,
          this.state.chart_code_readonly,
          this.state.chart_code_required,
          this.state.chart_code_length,
          this.state.chart_code_script,
          this.state.chart_code_tag,
          this.state.chart_code_type,
          this.state.chart_code_order,
          this.state.flag,
          this.state.flag_dbfield,
          this.state.flag_validate,
          this.state.flag_hide,
          this.state.flag_readonly,
          this.state.flag_required,
          this.state.flag_length,
          this.state.flag_script,
          this.state.flag_tag,
          this.state.flag_type,
          this.state.flag_order,
          this.state.payment_flag,
          this.state.payment_flag_dbfield,
          this.state.payment_flag_validate,
          this.state.payment_flag_hide,
          this.state.payment_flag_readonly,
          this.state.payment_flag_required,
          this.state.payment_flag_length,
          this.state.payment_flag_script,
          this.state.payment_flag_tag,
          this.state.payment_flag_type,
          this.state.payment_flag_order,
          this.state.calc_days,
          this.state.calc_days_dbfield,
          this.state.calc_days_validate,
          this.state.calc_days_hide,
          this.state.calc_days_readonly,
          this.state.calc_days_required,
          this.state.calc_days_length,
          this.state.calc_days_script,
          this.state.calc_days_tag,
          this.state.calc_days_type,
          this.state.calc_days_order,
          this.state.calc_weeks,
          this.state.calc_weeks_dbfield,
          this.state.calc_weeks_validate,
          this.state.calc_weeks_hide,
          this.state.calc_weeks_readonly,
          this.state.calc_weeks_required,
          this.state.calc_weeks_length,
          this.state.calc_weeks_script,
          this.state.calc_weeks_tag,
          this.state.calc_weeks_type,
          this.state.calc_weeks_order
        );
        this.setState({
          response,
        });
        if (!response.status) {
          toast.error("Insert operation failed. Please try again.", {
            autoClose: 5000,
          });
        } else {
          await this.getAllCustomListFields().then((response) => {
            if (response.status) {
              this.setState({ CustomListFields: response.result });
            }
          });
          toast.success(
            "Record has " +
              this.state.actionsubmission +
              " successfully.",
            { autoClose: 5000 }
          );
          $("#tagsForm").append(this.state.tagsFormHtml);
          //=========== reseting all states=======================================
          if (this.state.upadteableid !== "") {
            this.setState({
              recordupdating: "",
              actionsubmission: "added",
              upadteableid: "",
              updateabledata: "",
              // listHandler: "",
            });
          }
          this.setState({
            tagsFormHtml: "",
            actionsubmission: "added",
            isLoading: true,
            modalOpen: false,
            ad_modalOpen: false,
            deletestatus: false,
            UnitDescModalOpen: false,
            RateModalOpen: false,
            FactorModalOpen: false,
            AmountModalOpen: false,
            DaysInWeekdModalOpen: false,
            CappedModalOpen: false,
            DateFromModalOpen: false,
            DateToModalOpen: false,
            ChartModalOpen: false,
            ChartCodeModalOpen: false,
            FlagModalOpen: false,
            PaymentFlagModalOpen: false,
            CalcDaysModalOpen: false,
            CalcWeeksModalOpen: false,
            setupModalOpen: false,
            setupTrackingFieldEditModal: false,
            pmt_code: "",
            desc: "",
            TBA: null,
            unit: 0,
            unit_dbfield: null,
            unit_validate: null,
            unit_hide: null,
            unit_readonly: null,
            unit_required: null,
            unit_length: null,
            unit_script: null,
            unit_tag: null,
            unit_type: null,
            unit_order: 1,
            unit_desc: null,
            unit_desc_dbfield: null,
            unit_desc_validate: null,
            unit_desc_hide: null,
            unit_desc_readonly: null,
            unit_desc_required: null,
            unit_desc_length: null,
            unit_desc_script: null,
            unit_desc_tag: null,
            unit_desc_type: null,
            unit_desc_order: 2,
            rate: 0,
            rate_dbfield: null,
            rate_validate: null,
            rate_hide: null,
            rate_readonly: null,
            rate_required: null,
            rate_length: null,
            rate_script: null,
            rate_tag: null,
            rate_type: null,
            rate_order: 3,
            factor: 0,
            factor_dbfield: null,
            factor_validate: null,
            factor_hide: null,
            factor_readonly: null,
            factor_required: null,
            factor_length: null,
            factor_script: null,
            factor_tag: null,
            factor_type: null,
            factor_order: 4,
            amount: 0,
            amount_dbfield: null,
            amount_validate: null,
            amount_hide: null,
            amount_readonly: null,
            amount_required: null,
            amount_length: null,
            amount_script: null,
            amount_tag: null,
            amount_type: null,
            amount_order: 5,
            capped_amount: null,
            capped_amount_dbfield: null,
            capped_amount_validate: null,
            capped_amount_hide: null,
            capped_amount_readonly: null,
            capped_amount_required: null,
            capped_amount_length: null,
            capped_amount_script: null,
            capped_amount_tag: null,
            capped_amount_type: null,
            capped_amount_order: 6,
            days_in_week: null,
            days_in_week_dbfield: null,
            days_in_week_validate: null,
            days_in_week_hide: null,
            days_in_week_readonly: null,
            days_in_week_required: null,
            days_in_week_length: null,
            days_in_week_script: null,
            days_in_week_tag: null,
            days_in_week_type: null,
            days_in_week_order: 7,
            startDate: moment(),
            startDate_dbfield: null,
            startDate_validate: null,
            startDate_hide: null,
            startDate_readonly: null,
            startDate_required: null,
            startDate_length: null,
            startDate_script: null,
            startDate_tag: null,
            startDate_type: null,
            startDate_order: 8,
            endDate: moment().add(1, "days"),
            endDate_dbfield: null,
            endDate_validate: null,
            endDate_hide: null,
            endDate_readonly: null,
            endDate_required: null,
            endDate_length: null,
            endDate_script: null,
            endDate_tag: null,
            endDate_type: null,
            endDate_order: 9,
            chart_sort: null,
            chart_sort_dbfield: null,
            chart_sort_validate: null,
            chart_sort_hide: null,
            chart_sort_readonly: null,
            chart_sort_required: null,
            chart_sort_length: null,
            chart_sort_script: null,
            chart_sort_tag: null,
            chart_sort_type: null,
            chart_sort_order: 10,
            chart_code: null,
            chart_code_dbfield: null,
            chart_code_validate: null,
            chart_code_hide: null,
            chart_code_readonly: null,
            chart_code_required: null,
            chart_code_length: null,
            chart_code_script: null,
            chart_code_tag: null,
            chart_code_type: null,
            chart_code_order: 11,
            flag: null,
            flag_dbfield: null,
            flag_validate: null,
            flag_hide: null,
            flag_readonly: null,
            flag_required: null,
            flag_length: null,
            flag_script: null,
            flag_tag: null,
            flag_type: null,
            flag_order: 12,
            payment_flag: null,
            payment_flag_dbfield: null,
            payment_flag_validate: null,
            payment_flag_hide: null,
            payment_flag_readonly: null,
            payment_flag_required: null,
            payment_flag_length: null,
            payment_flag_script: null,
            payment_flag_tag: null,
            payment_flag_type: null,
            payment_flag_order: 13,
            calc_days: null,
            calc_days_dbfield: null,
            calc_days_validate: null,
            calc_days_hide: null,
            calc_days_readonly: null,
            calc_days_required: null,
            calc_days_length: null,
            calc_days_script: null,
            calc_days_tag: null,
            calc_days_type: null,
            calc_days_order: 14,
            calc_weeks: null,
            calc_weeks_dbfield: null,
            calc_weeks_validate: null,
            calc_weeks_hide: null,
            calc_weeks_readonly: null,
            calc_weeks_required: null,
            calc_weeks_length: null,
            calc_weeks_script: null,
            calc_weeks_tag: null,
            calc_weeks_type: null,
            calc_weeks_order: 15,
            formErrors: {
              pmt_code: "",
              desc: "",
              unit: "",
              unit_desc: "",
              rate: "",
              factor: "",
              amount: "",
              capped_amount: "",
              days_in_week: "",
              chart_sort: "",
              chart_code: "",
              flag: "",
              payment_flag: "",
            },
            chart_sortValid: "",
            payment_flagValid: "",
            flagValid: "",
            PmtCodeValid: "",
            unit_descValid: "",
            descValid: "",
            days_in_weekValid: "",
            unitValid: "",
            rateValid: "",
            amountValid: "",
            chart_codeValid: "",
            capped_amountValid: "",
            factorValid: "",
            formValid: "",
            isActive: "",
          });
          //=========== end reseting all states===================================
        }
      } catch (e) {
        toast.error(e.message, { autoClose: 5000 });
      }
      this.setState({ isLoading: false });
    }
  };

  handleinLineEdit = async (event) => {
    //  event.preventDefault();
    let pmt_code = this.state.pmt_code;
    let desc = this.state.desc;
    let formErrors = Object.assign({}, this.state.formErrors);
    if (pmt_code === false || pmt_code === null || pmt_code === "") {
      formErrors.pmt_code = "This field is required";
    }
    if (desc === false || desc === null || desc === "") {
      formErrors.desc = "This field is required";
      $("#addCustomFieldlistmodal .modal-body").scrollTop(0);
    }
    if (pmt_code === false || pmt_code === null || pmt_code === "") {
      formErrors.pmt_code = "This field is required";
      $("#addCustomFieldlistmodal .modal-body").scrollTop(0);
    }
    this.setState({ formErrors });

    this.setState({
      isLoading: true,
    });

    try {
      // this.onad_ModalClose();
      const response = await this.insertCustomFieldsList(
        this.state.upadteableid,
        this.state.pmt_code,
        this.state.desc,
        this.state.TBA,
        this.state.unit,
        this.state.unit_dbfield,
        this.state.unit_validate,
        this.state.unit_hide,
        this.state.unit_readonly,
        this.state.unit_required,
        this.state.unit_length,
        this.state.unit_script,
        this.state.unit_tag,
        this.state.unit_type,
        this.state.unit_order,
        this.state.unit_desc,
        this.state.unit_desc_dbfield,
        this.state.unit_desc_validate,
        this.state.unit_desc_hide,
        this.state.unit_desc_readonly,
        this.state.unit_desc_required,
        this.state.unit_desc_length,
        this.state.unit_desc_script,
        this.state.unit_desc_tag,
        this.state.unit_desc_type,
        this.state.unit_desc_order,
        this.state.rate,
        this.state.rate_dbfield,
        this.state.rate_validate,
        this.state.rate_hide,
        this.state.rate_readonly,
        this.state.rate_required,
        this.state.rate_length,
        this.state.rate_script,
        this.state.rate_tag,
        this.state.rate_type,
        this.state.rate_order,
        this.state.factor,
        this.state.factor_dbfield,
        this.state.factor_validate,
        this.state.factor_hide,
        this.state.factor_readonly,
        this.state.factor_required,
        this.state.factor_length,
        this.state.factor_script,
        this.state.factor_tag,
        this.state.factor_type,
        this.state.factor_order,
        this.state.amount,
        this.state.amount_dbfield,
        this.state.amount_validate,
        this.state.amount_hide,
        this.state.amount_readonly,
        this.state.amount_required,
        this.state.amount_length,
        this.state.amount_script,
        this.state.amount_tag,
        this.state.amount_type,
        this.state.amount_order,
        this.state.capped_amount,
        this.state.capped_amount_dbfield,
        this.state.capped_amount_validate,
        this.state.capped_amount_hide,
        this.state.capped_amount_readonly,
        this.state.capped_amount_required,
        this.state.capped_amount_length,
        this.state.capped_amount_script,
        this.state.capped_amount_tag,
        this.state.capped_amount_type,
        this.state.capped_amount_order,
        this.state.days_in_week,
        this.state.days_in_week_dbfield,
        this.state.days_in_week_validate,
        this.state.days_in_week_hide,
        this.state.days_in_week_readonly,
        this.state.days_in_week_required,
        this.state.days_in_week_length,
        this.state.days_in_week_script,
        this.state.days_in_week_tag,
        this.state.days_in_week_type,
        this.state.days_in_week_order,
        moment.tz(this.state.startDate, "Australia/Canberra").format(),
        this.state.startDate_dbfield,
        this.state.startDate_validate,
        this.state.startDate_hide,
        this.state.startDate_readonly,
        this.state.startDate_required,
        this.state.startDate_length,
        this.state.startDate_script,
        this.state.startDate_tag,
        this.state.startDate_type,
        this.state.startDate_order,
        moment.tz(this.state.endDate, "Australia/Canberra").format(),
        this.state.endDate_dbfield,
        this.state.endDate_validate,
        this.state.endDate_hide,
        this.state.endDate_readonly,
        this.state.endDate_required,
        this.state.endDate_length,
        this.state.endDate_script,
        this.state.endDate_tag,
        this.state.endDate_type,
        this.state.endDate_order,
        this.state.chart_sort,
        this.state.chart_sort_dbfield,
        this.state.chart_sort_validate,
        this.state.chart_sort_hide,
        this.state.chart_sort_readonly,
        this.state.chart_sort_required,
        this.state.chart_sort_length,
        this.state.chart_sort_script,
        this.state.chart_sort_tag,
        this.state.chart_sort_type,
        this.state.chart_sort_order,
        this.state.chart_code,
        this.state.chart_code_dbfield,
        this.state.chart_code_validate,
        this.state.chart_code_hide,
        this.state.chart_code_readonly,
        this.state.chart_code_required,
        this.state.chart_code_length,
        this.state.chart_code_script,
        this.state.chart_code_tag,
        this.state.chart_code_type,
        this.state.chart_code_order,
        this.state.flag,
        this.state.flag_dbfield,
        this.state.flag_validate,
        this.state.flag_hide,
        this.state.flag_readonly,
        this.state.flag_required,
        this.state.flag_length,
        this.state.flag_script,
        this.state.flag_tag,
        this.state.flag_type,
        this.state.flag_order,
        this.state.payment_flag,
        this.state.payment_flag_dbfield,
        this.state.payment_flag_validate,
        this.state.payment_flag_hide,
        this.state.payment_flag_readonly,
        this.state.payment_flag_required,
        this.state.payment_flag_length,
        this.state.payment_flag_script,
        this.state.payment_flag_tag,
        this.state.payment_flag_type,
        this.state.payment_flag_order,
        this.state.calc_days,
        this.state.calc_days_dbfield,
        this.state.calc_days_validate,
        this.state.calc_days_hide,
        this.state.calc_days_readonly,
        this.state.calc_days_required,
        this.state.calc_days_length,
        this.state.calc_days_script,
        this.state.calc_days_tag,
        this.state.calc_days_type,
        this.state.calc_days_order,
        this.state.calc_weeks,
        this.state.calc_weeks_dbfield,
        this.state.calc_weeks_validate,
        this.state.calc_weeks_hide,
        this.state.calc_weeks_readonly,
        this.state.calc_weeks_required,
        this.state.calc_weeks_length,
        this.state.calc_weeks_script,
        this.state.calc_weeks_tag,
        this.state.calc_weeks_type,
        this.state.calc_weeks_order
      );
      this.setState({
        response,
      });
      if (!response.status) {
        toast.error("Insert operation failed. Please try again.", {
          autoClose: 5000,
        });
      } else {
        await this.getAllCustomListFields().then((response) => {
          console.log("=>Check", response);
          if (response.status) {
            this.setState({ CustomListFields: response.result });
          }
        });
        toast.success(
          "Record has " +
            this.state.actionsubmission +
            " successfully.",
          { autoClose: 5000 }
        );
        $("#tagsForm").append(this.state.tagsFormHtml);
        //=========== reseting all states=======================================
        if (this.state.upadteableid !== "") {
          this.setState({
            recordupdating: "",
            actionsubmission: "added",
            upadteableid: "",
            updateabledata: "",
          });
        }
        this.setState({
          tagsFormHtml: "",
          actionsubmission: "added",
          isLoading: true,
          modalOpen: false,
          ad_modalOpen: false,
          deletestatus: false,
          UnitDescModalOpen: false,
          RateModalOpen: false,
          FactorModalOpen: false,
          AmountModalOpen: false,
          DaysInWeekdModalOpen: false,
          CappedModalOpen: false,
          DateFromModalOpen: false,
          DateToModalOpen: false,
          ChartModalOpen: false,
          ChartCodeModalOpen: false,
          FlagModalOpen: false,
          PaymentFlagModalOpen: false,
          CalcDaysModalOpen: false,
          CalcWeeksModalOpen: false,
          setupModalOpen: false,
          setupTrackingFieldEditModal: false,
          pmt_code: "",
          desc: "",
          TBA: null,
          unit: 0,
          unit_dbfield: null,
          unit_validate: null,
          unit_hide: null,
          unit_readonly: null,
          unit_required: null,
          unit_length: null,
          unit_script: null,
          unit_tag: null,
          unit_type: null,
          unit_order: 1,
          unit_desc: null,
          unit_desc_dbfield: null,
          unit_desc_validate: null,
          unit_desc_hide: null,
          unit_desc_readonly: null,
          unit_desc_required: null,
          unit_desc_length: null,
          unit_desc_script: null,
          unit_desc_tag: null,
          unit_desc_type: null,
          unit_desc_order: 2,
          rate: 0,
          rate_dbfield: null,
          rate_validate: null,
          rate_hide: null,
          rate_readonly: null,
          rate_required: null,
          rate_length: null,
          rate_script: null,
          rate_tag: null,
          rate_type: null,
          rate_order: 3,
          factor: 0,
          factor_dbfield: null,
          factor_validate: null,
          factor_hide: null,
          factor_readonly: null,
          factor_required: null,
          factor_length: null,
          factor_script: null,
          factor_tag: null,
          factor_type: null,
          factor_order: 4,
          amount: 0,
          amount_dbfield: null,
          amount_validate: null,
          amount_hide: null,
          amount_readonly: null,
          amount_required: null,
          amount_length: null,
          amount_script: null,
          amount_tag: null,
          amount_type: null,
          amount_order: 5,
          capped_amount: null,
          capped_amount_dbfield: null,
          capped_amount_validate: null,
          capped_amount_hide: null,
          capped_amount_readonly: null,
          capped_amount_required: null,
          capped_amount_length: null,
          capped_amount_script: null,
          capped_amount_tag: null,
          capped_amount_type: null,
          capped_amount_order: 6,
          days_in_week: null,
          days_in_week_dbfield: null,
          days_in_week_validate: null,
          days_in_week_hide: null,
          days_in_week_readonly: null,
          days_in_week_required: null,
          days_in_week_length: null,
          days_in_week_script: null,
          days_in_week_tag: null,
          days_in_week_type: null,
          days_in_week_order: 7,
          startDate: moment(),
          startDate_dbfield: null,
          startDate_validate: null,
          startDate_hide: null,
          startDate_readonly: null,
          startDate_required: null,
          startDate_length: null,
          startDate_script: null,
          startDate_tag: null,
          startDate_type: null,
          startDate_order: 8,
          endDate: moment().add(1, "days"),
          endDate_dbfield: null,
          endDate_validate: null,
          endDate_hide: null,
          endDate_readonly: null,
          endDate_required: null,
          endDate_length: null,
          endDate_script: null,
          endDate_tag: null,
          endDate_type: null,
          endDate_order: 9,
          chart_sort: null,
          chart_sort_dbfield: null,
          chart_sort_validate: null,
          chart_sort_hide: null,
          chart_sort_readonly: null,
          chart_sort_required: null,
          chart_sort_length: null,
          chart_sort_script: null,
          chart_sort_tag: null,
          chart_sort_type: null,
          chart_sort_order: 10,
          chart_code: null,
          chart_code_dbfield: null,
          chart_code_validate: null,
          chart_code_hide: null,
          chart_code_readonly: null,
          chart_code_required: null,
          chart_code_length: null,
          chart_code_script: null,
          chart_code_tag: null,
          chart_code_type: null,
          chart_code_order: 11,
          flag: null,
          flag_dbfield: null,
          flag_validate: null,
          flag_hide: null,
          flag_readonly: null,
          flag_required: null,
          flag_length: null,
          flag_script: null,
          flag_tag: null,
          flag_type: null,
          flag_order: 12,
          payment_flag: null,
          payment_flag_dbfield: null,
          payment_flag_validate: null,
          payment_flag_hide: null,
          payment_flag_readonly: null,
          payment_flag_required: null,
          payment_flag_length: null,
          payment_flag_script: null,
          payment_flag_tag: null,
          payment_flag_type: null,
          payment_flag_order: 13,
          calc_days: null,
          calc_days_dbfield: null,
          calc_days_validate: null,
          calc_days_hide: null,
          calc_days_readonly: null,
          calc_days_required: null,
          calc_days_length: null,
          calc_days_script: null,
          calc_days_tag: null,
          calc_days_type: null,
          calc_days_order: 14,
          calc_weeks: null,
          calc_weeks_dbfield: null,
          calc_weeks_validate: null,
          calc_weeks_hide: null,
          calc_weeks_readonly: null,
          calc_weeks_required: null,
          calc_weeks_length: null,
          calc_weeks_script: null,
          calc_weeks_tag: null,
          calc_weeks_type: null,
          calc_weeks_order: 15,
          formErrors: {
            pmt_code: "",
            desc: "",
            unit: "",
            unit_desc: "",
            rate: "",
            factor: "",
            amount: "",
            capped_amount: "",
            days_in_week: "",
            chart_sort: "",
            chart_code: "",
            flag: "",
            payment_flag: "",
          },
          chart_sortValid: "",
          payment_flagValid: "",
          flagValid: "",
          PmtCodeValid: "",
          unit_descValid: "",
          descValid: "",
          days_in_weekValid: "",
          unitValid: "",
          rateValid: "",
          amountValid: "",
          chart_codeValid: "",
          capped_amountValid: "",
          factorValid: "",
          formValid: "",
          isActive: "",
        });
        //=========== end reseting all states===================================
      }
    } catch (e) {
      toast.error(e.message, { autoClose: 5000 });
    }
    this.setState({ isLoading: false });
  };

  updateCellsvalue = async (event, index, key, date) => {
    var eDate;
    var eDate_dbfield;
    var eDate_validate;
    var eDate_hide;
    var eDate_readonly;
    var eDate_required;
    var eDate_length;
    var eDate_script;
    var eDate_tag;
    var eDate_type;
    var eDate_order;

    var sDate;
    var sDate_dbfield;
    var sDate_validate;
    var sDate_hide;
    var sDate_readonly;
    var sDate_required;
    var sDate_length;
    var sDate_script;
    var sDate_tag;
    var sDate_type;
    var sDate_order;

    var unitV;
    var unitV_dbfield;
    var unitV_validate;
    var unitV_hide;
    var unitV_readonly;
    var unitV_required;
    var unitV_length;
    var unitV_script;
    var unitV_tag;
    var unitV_type;
    var unitV_order;

    var unitDes;
    var unitDes_dbfield;
    var unitDes_validate;
    var unitDes_hide;
    var unitDes_readonly;
    var unitDes_required;
    var unitDes_length;
    var unitDes_script;
    var unitDes_tag;
    var unitDes_type;
    var unitDes_order;

    var rateV;
    var rateV_dbfield;
    var rateV_validate;
    var rateV_hide;
    var rateV_readonly;
    var rateV_required;
    var rateV_length;
    var rateV_script;
    var rateV_tag;
    var rateV_type;
    var rateV_order;

    var factorV;
    var factorV_dbfield;
    var factorV_validate;
    var factorV_hide;
    var factorV_readonly;
    var factorV_required;
    var factorV_length;
    var factorV_script;
    var factorV_tag;
    var factorV_type;
    var factorV_order;

    var amountV;
    var amountV_dbfield;
    var amountV_validate;
    var amountV_hide;
    var amountV_readonly;
    var amountV_required;
    var amountV_length;
    var amountV_script;
    var amountV_tag;
    var amountV_type;
    var amountV_order;

    var calcWeeks;
    var calcWeeks_dbfield;
    var calcWeeks_validate;
    var calcWeeks_hide;
    var calcWeeks_readonly;
    var calcWeeks_required;
    var calcWeeks_length;
    var calcWeeks_script;
    var calcWeeks_tag;
    var calcWeeks_type;
    var calcWeeks_order;

    var calcDays;
    var calcDays_dbfield;
    var calcDays_validate;
    var calcDays_hide;
    var calcDays_readonly;
    var calcDays_required;
    var calcDays_length;
    var calcDays_script;
    var calcDays_tag;
    var calcDays_type;
    var calcDays_order;

    var dayWeek;
    var dayWeek_dbfield;
    var dayWeek_validate;
    var dayWeek_hide;
    var dayWeek_readonly;
    var dayWeek_required;
    var dayWeek_length;
    var dayWeek_script;
    var dayWeek_tag;
    var dayWeek_type;
    var dayWeek_order;

    var cap_amountV;
    var cap_amountV_dbfield;
    var cap_amountV_validate;
    var cap_amountV_hide;
    var cap_amountV_readonly;
    var cap_amountV_required;
    var cap_amountV_length;
    var cap_amountV_script;
    var cap_amountV_tag;
    var cap_amountV_type;
    var cap_amountV_order;

    var chart_S;
    var chart_S_dbfield;
    var chart_S_validate;
    var chart_S_hide;
    var chart_S_readonly;
    var chart_S_required;
    var chart_S_length;
    var chart_S_script;
    var chart_S_tag;
    var chart_S_type;
    var chart_S_order;

    var chart_C;
    var chart_C_dbfield;
    var chart_C_validate;
    var chart_C_hide;
    var chart_C_readonly;
    var chart_C_required;
    var chart_C_length;
    var chart_C_script;
    var chart_C_tag;
    var chart_C_type;
    var chart_C_order;

    var flagV;
    var flagV_dbfield;
    var flagV_validate;
    var flagV_hide;
    var flagV_readonly;
    var flagV_required;
    var flagV_length;
    var flagV_script;
    var flagV_tag;
    var flagV_type;
    var flagV_order;

    var pay_flag;
    var pay_flag_dbfield;
    var pay_flag_validate;
    var pay_flag_hide;
    var pay_flag_readonly;
    var pay_flag_required;
    var pay_flag_length;
    var pay_flag_script;
    var pay_flag_tag;
    var pay_flag_type;
    var pay_flag_order;

    this.state.CustomListFields[index].CustomFields.map((obj, i) => {
      if (obj.Desc === "Units") {
        unitV = obj.Value;
        unitV_dbfield = obj.DBField;
        unitV_hide = obj.Hide;
        unitV_length = obj.Length;
        unitV_order = obj.Order;
        unitV_readonly = obj.Readonly;
        unitV_required = obj.Required;
        unitV_script = obj.Script;
        unitV_tag = obj.Tag;
        unitV_type = obj.Type;
        unitV_validate = obj.Validate;
      }
      if (obj.Desc === "Unit Desc") {
        unitDes = obj.Value;
        unitDes_dbfield = obj.DBField;
        unitDes_hide = obj.Hide;
        unitDes_length = obj.Length;
        unitDes_order = obj.Order;
        unitDes_readonly = obj.Readonly;
        unitDes_required = obj.Required;
        unitDes_script = obj.Script;
        unitDes_tag = obj.Tag;
        unitDes_type = obj.Type;
        unitDes_validate = obj.Validate;
      }
      if (obj.Desc === "Rate") {
        rateV = obj.Value;
        rateV_dbfield = obj.DBField;
        rateV_hide = obj.Hide;
        rateV_length = obj.Length;
        rateV_order = obj.Order;
        rateV_readonly = obj.Readonly;
        rateV_required = obj.Required;
        rateV_script = obj.Script;
        rateV_tag = obj.Tag;
        rateV_type = obj.Type;
        rateV_validate = obj.Validate;
      }
      if (obj.Desc === "Factor") {
        factorV = obj.Value;

        factorV_dbfield = obj.DBField;
        factorV_hide = obj.Hide;
        factorV_length = obj.Length;
        factorV_order = obj.Order;
        factorV_readonly = obj.Readonly;
        factorV_required = obj.Required;
        factorV_script = obj.Script;
        factorV_tag = obj.Tag;
        factorV_type = obj.Type;
        factorV_validate = obj.Validate;
      }
      if (obj.Desc === "Date To:") {
        eDate = obj.Value;

        eDate_dbfield = obj.DBField;
        eDate_hide = obj.Hide;
        eDate_length = obj.Length;
        eDate_order = obj.Order;
        eDate_readonly = obj.Readonly;
        eDate_required = obj.Required;
        eDate_script = obj.Script;
        eDate_tag = obj.Tag;
        eDate_type = obj.Type;
        eDate_validate = obj.Validate;
      }
      if (obj.Desc === "Date From:") {
        sDate = obj.Value;

        sDate_dbfield = obj.DBField;
        sDate_hide = obj.Hide;
        sDate_length = obj.Length;
        sDate_order = obj.Order;
        sDate_readonly = obj.Readonly;
        sDate_required = obj.Required;
        sDate_script = obj.Script;
        sDate_tag = obj.Tag;
        sDate_type = obj.Type;
        sDate_validate = obj.Validate;
      }
      if (obj.Desc === "Amount") {
        amountV = obj.Value;

        amountV_dbfield = obj.DBField;
        amountV_hide = obj.Hide;
        amountV_length = obj.Length;
        amountV_order = obj.Order;
        amountV_readonly = obj.Readonly;
        amountV_required = obj.Required;
        amountV_script = obj.Script;
        amountV_tag = obj.Tag;
        amountV_type = obj.Type;
        amountV_validate = obj.Validate;
      }
      if (obj.Desc === "Capped Amount") {
        cap_amountV = obj.Value;

        cap_amountV_dbfield = obj.DBField;
        cap_amountV_hide = obj.Hide;
        cap_amountV_length = obj.Length;
        cap_amountV_order = obj.Order;
        cap_amountV_readonly = obj.Readonly;
        cap_amountV_required = obj.Required;
        cap_amountV_script = obj.Script;
        cap_amountV_tag = obj.Tag;
        cap_amountV_type = obj.Type;
        cap_amountV_validate = obj.Validate;
      }
      if (obj.Desc === "Chart Sort") {
        chart_S = obj.Value;

        chart_S_dbfield = obj.DBField;
        chart_S_hide = obj.Hide;
        chart_S_length = obj.Length;
        chart_S_order = obj.Order;
        chart_S_readonly = obj.Readonly;
        chart_S_required = obj.Required;
        chart_S_script = obj.Script;
        chart_S_tag = obj.Tag;
        chart_S_type = obj.Type;
        chart_S_validate = obj.Validate;
      }
      if (obj.Desc === "Chart Code") {
        chart_C = obj.Value;

        chart_C_dbfield = obj.DBField;
        chart_C_hide = obj.Hide;
        chart_C_length = obj.Length;
        chart_C_order = obj.Order;
        chart_C_readonly = obj.Readonly;
        chart_C_required = obj.Required;
        chart_C_script = obj.Script;
        chart_C_tag = obj.Tag;
        chart_C_type = obj.Type;
        chart_C_validate = obj.Validate;
      }
      if (obj.Desc === "Flag:") {
        flagV = obj.Value;

        flagV_dbfield = obj.DBField;
        flagV_hide = obj.Hide;
        flagV_length = obj.Length;
        flagV_order = obj.Order;
        flagV_readonly = obj.Readonly;
        flagV_required = obj.Required;
        flagV_script = obj.Script;
        flagV_tag = obj.Tag;
        flagV_type = obj.Type;
        flagV_validate = obj.Validate;
      }
      if (obj.Desc === "Payment Flag:") {
        pay_flag = obj.Value;

        pay_flag_dbfield = obj.DBField;
        pay_flag_hide = obj.Hide;
        pay_flag_length = obj.Length;
        pay_flag_order = obj.Order;
        pay_flag_readonly = obj.Readonly;
        pay_flag_required = obj.Required;
        pay_flag_script = obj.Script;
        pay_flag_tag = obj.Tag;
        pay_flag_type = obj.Type;
        pay_flag_validate = obj.Validate;
      }
      if (obj.Desc === "Calc Days") {
        calcDays = obj.Value;

        calcDays_dbfield = obj.DBField;
        calcDays_hide = obj.Hide;
        calcDays_length = obj.Length;
        calcDays_order = obj.Order;
        calcDays_readonly = obj.Readonly;
        calcDays_required = obj.Required;
        calcDays_script = obj.Script;
        calcDays_tag = obj.Tag;
        calcDays_type = obj.Type;
        calcDays_validate = obj.Validate;
      }
      if (obj.Desc === "Calc Weeks") {
        calcWeeks = obj.Value;

        calcWeeks_dbfield = obj.DBField;
        calcWeeks_hide = obj.Hide;
        calcWeeks_length = obj.Length;
        calcWeeks_order = obj.Order;
        calcWeeks_readonly = obj.Readonly;
        calcWeeks_required = obj.Required;
        calcWeeks_script = obj.Script;
        calcWeeks_tag = obj.Tag;
        calcWeeks_type = obj.Type;
        calcWeeks_validate = obj.Validate;
      }
      if (obj.Desc === "Days in Week") {
        dayWeek = obj.Value;

        dayWeek_dbfield = obj.DBField;
        dayWeek_hide = obj.Hide;
        dayWeek_length = obj.Length;
        dayWeek_order = obj.Order;
        dayWeek_readonly = obj.Readonly;
        dayWeek_required = obj.Required;
        dayWeek_script = obj.Script;
        dayWeek_tag = obj.Tag;
        dayWeek_type = obj.Type;
        dayWeek_validate = obj.Validate;
      }
    });

    if (key === "TBA") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var value = this.state.CustomListFields[index].TBA;
      if (value === "" || value === null) {
        value = "checked";
      } else {
        value = null;
      }
      if (value === "checked") {
        calcDays = 0;
        calcWeeks = 0;
      }
      console.log("=>CHeck", value);
      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: code,
          desc: name,
          TBA: value,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }

    if (key === "Code") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;
      if (value !== "") {
        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: value,
            desc: name,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        toast.error("Code Value can't be Empty", {
          autoClose: 5000,
        });
      }
    }

    if (key === "Name") {
      var Guid = this.state.CustomListFields[index].Guid;
      var code = this.state.CustomListFields[index].Code;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;
      if (value !== "") {
        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: code,
            desc: value,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        toast.error("Name Value can't be Empty", {
          autoClose: 5000,
        });
      }
    }

    if (key === "StartDate") {
      console.log(event, index, key);
      var Guid = this.state.CustomListFields[index].Guid;
      var code = this.state.CustomListFields[index].Code;
      var c_desc = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = moment(event);
      let startDate = moment(event.format("YYYY-MM-DD"));
      let endDate = moment(eDate);
      if (startDate.isSameOrBefore(endDate.format("YYYY-MM-DD"))) {
        eDate = moment(eDate);
        var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
        var calc_weeks = endDate.diff(startDate, "weeks");

        if (calc_days >= dayWeek) {
          calc_days = 0;
          calc_weeks++;
          calcDays = 0;
          calcWeeks = calc_weeks;
        } else {
          if (calc_days === 0) {
            calc_weeks++;
          }
          calcDays = calc_days;
          calcWeeks = calc_weeks;
        }

        console.log(">>>>>.", calcDays, calcWeeks, dayWeek);

        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: code,
            desc: c_desc,
            TBA: TBA,
            startDate: value,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        console.log(">>>>ELSE CASE");
        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: code,
            desc: c_desc,
            TBA: TBA,
            startDate: value,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: Math.floor(calcWeeks),
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: Math.floor(calcDays),
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      }
    }
    if (key === "EndDate") {
      console.log(event, index, key);
      var Guid = this.state.CustomListFields[index].Guid;
      var code = this.state.CustomListFields[index].Code;
      var c_desc = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = moment(event);
      let startDate = moment(sDate);
      let endDate = moment(event.format("YYYY-MM-DD"));
      if (moment(event).isSameOrAfter(startDate.format("YYYY-MM-DD"))) {
        var calc_days = (endDate.diff(startDate, "days") + 1) % 7;
        var calc_weeks = endDate.diff(startDate, "weeks");

        if (calc_days >= dayWeek) {
          calc_days = 0;
          calc_weeks++;
          calcDays = 0;
          calcWeeks = calc_weeks;
        } else {
          if (calc_days === 0) {
            calc_weeks++;
          }
          calcDays = calc_days;
          calcWeeks = calc_weeks;
        }

        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: code,
            desc: c_desc,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: value,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        console.log("OKKKKKKK");
        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: code,
            desc: c_desc,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: value,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      }
    }

    if (key === "Unit") {
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;
      var amountV = factorV * rateV * value;
      if (value >= 0) {
        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: Code,
            desc: name,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: value,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        toast.error("Invalid Value of Unit", { autoClose: 5000 });
      }
    }
    if (key === "UnitDesc") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: value,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }
    if (key === "ChartSort") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: value,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }

    if (key === "ChartCode") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: value,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }
    if (key === "CappedAmount") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: value,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }
    if (key === "Flag") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: value,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: pay_flag,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }
    if (key === "PaymentFlag") {
      console.log(this.state.CustomListFields);
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;

      await this.setState(
        {
          upadteableid: Guid,
          recordupdating: true,
          pmt_code: Code,
          desc: name,
          TBA: TBA,
          startDate: sDate,
          startDate_dbfield: sDate_dbfield,
          startDate_validate: sDate_validate,
          startDate_hide: sDate_hide,
          startDate_readonly: sDate_readonly,
          startDate_required: sDate_required,
          startDate_length: sDate_length,
          startDate_script: sDate_script,
          startDate_tag: sDate_tag,
          startDate_type: sDate_type,
          startDate_order: sDate_order,

          endDate: eDate,
          endDate_dbfield: eDate_dbfield,
          endDate_validate: eDate_validate,
          endDate_hide: eDate_hide,
          endDate_readonly: eDate_readonly,
          endDate_required: eDate_required,
          endDate_length: eDate_length,
          endDate_script: eDate_script,
          endDate_tag: eDate_tag,
          endDate_type: eDate_type,
          endDate_order: eDate_order,

          actionsubmission: "updated",
          unit: unitV,
          unit_dbfield: unitV_dbfield,
          unit_validate: unitV_validate,
          unit_hide: unitV_hide,
          unit_readonly: unitV_readonly,
          unit_required: unitV_required,
          unit_length: unitV_length,
          unit_script: unitV_script,
          unit_tag: unitV_tag,
          unit_type: unitV_type,
          unit_order: unitV_order,

          unit_desc: unitDes,
          unit_desc_dbfield: unitDes_dbfield,
          unit_desc_validate: unitDes_validate,
          unit_desc_hide: unitDes_hide,
          unit_desc_readonly: unitDes_readonly,
          unit_desc_required: unitDes_required,
          unit_desc_length: unitDes_length,
          unit_desc_script: unitDes_script,
          unit_desc_tag: unitDes_tag,
          unit_desc_type: unitDes_type,
          unit_desc_order: unitDes_order,

          rate: rateV,
          rate_dbfield: rateV_dbfield,
          rate_validate: rateV_validate,
          rate_hide: rateV_hide,
          rate_readonly: rateV_readonly,
          rate_required: rateV_required,
          rate_length: rateV_length,
          rate_script: rateV_script,
          rate_tag: rateV_tag,
          rate_type: rateV_type,
          rate_order: rateV_order,

          factor: factorV,
          factor_dbfield: factorV_dbfield,
          factor_validate: factorV_validate,
          factor_hide: factorV_hide,
          factor_readonly: factorV_readonly,
          factor_required: factorV_required,
          factor_length: factorV_length,
          factor_script: factorV_script,
          factor_tag: factorV_tag,
          factor_type: factorV_type,
          factor_order: factorV_order,

          amount: amountV,
          amount_dbfield: amountV_dbfield,
          amount_validate: amountV_validate,
          amount_hide: amountV_hide,
          amount_readonly: amountV_readonly,
          amount_required: amountV_required,
          amount_length: amountV_length,
          amount_script: amountV_script,
          amount_tag: amountV_tag,
          amount_type: amountV_type,
          amount_order: amountV_order,

          calc_weeks: calcWeeks,
          calc_weeks_dbfield: calcWeeks_dbfield,
          calc_weeks_validate: calcWeeks_validate,
          calc_weeks_hide: calcWeeks_hide,
          calc_weeks_readonly: calcWeeks_readonly,
          calc_weeks_required: calcWeeks_required,
          calc_weeks_length: calcWeeks_length,
          calc_weeks_script: calcWeeks_script,
          ecalc_weeks_tag: calcWeeks_tag,
          calc_weeks_type: calcWeeks_type,
          calc_weeks_order: calcWeeks_order,

          calc_days: calcDays,
          calc_days_dbfield: calcDays_dbfield,
          calc_days_validate: calcDays_validate,
          calc_days_hide: calcDays_hide,
          calc_days_readonly: calcDays_readonly,
          calc_days_required: calcDays_required,
          calc_days_length: calcDays_length,
          calc_days_script: calcDays_script,
          calc_days_tag: calcDays_tag,
          calc_days_type: calcDays_type,
          calc_days_order: calcDays_order,

          days_in_week: dayWeek,
          days_in_week_dbfield: dayWeek_dbfield,
          days_in_week_validate: dayWeek_validate,
          days_in_week_hide: dayWeek_hide,
          days_in_week_readonly: dayWeek_readonly,
          days_in_week_required: dayWeek_required,
          days_in_week_length: dayWeek_length,
          days_in_week_script: dayWeek_script,
          days_in_week_tag: dayWeek_tag,
          days_in_week_type: dayWeek_type,
          days_in_week_order: dayWeek_order,

          capped_amount: cap_amountV,
          capped_amount_dbfield: cap_amountV_dbfield,
          capped_amount_validate: cap_amountV_validate,
          capped_amount_hide: cap_amountV_hide,
          capped_amount_readonly: cap_amountV_readonly,
          capped_amount_required: cap_amountV_required,
          capped_amount_length: cap_amountV_length,
          capped_amount_script: cap_amountV_script,
          capped_amount_tag: cap_amountV_tag,
          capped_amount_type: cap_amountV_type,
          capped_amount_order: cap_amountV_order,

          chart_sort: chart_S,
          chart_sort_dbfield: chart_S_dbfield,
          chart_sort_validate: chart_S_validate,
          chart_sort_hide: chart_S_hide,
          chart_sort_readonly: chart_S_readonly,
          chart_sort_required: chart_S_required,
          chart_sort_length: chart_S_length,
          chart_sort_script: chart_S_script,
          chart_sort_tag: chart_S_tag,
          chart_sort_type: chart_S_type,
          chart_sort_order: chart_S_order,

          chart_code: chart_C,
          chart_code_dbfield: chart_C_dbfield,
          chart_code_validate: chart_C_validate,
          chart_code_hide: chart_C_hide,
          chart_code_readonly: chart_C_readonly,
          chart_code_required: chart_C_required,
          chart_code_length: chart_C_length,
          chart_code_script: chart_C_script,
          chart_code_tag: chart_C_tag,
          chart_code_type: chart_C_type,
          chart_code_order: chart_C_order,

          flag: flagV,
          flag_dbfield: flagV_dbfield,
          flag_validate: flagV_validate,
          flag_hide: flagV_hide,
          flag_readonly: flagV_readonly,
          flag_required: flagV_required,
          flag_length: flagV_length,
          flag_script: flagV_script,
          flag_tag: flagV_tag,
          flag_type: flagV_type,
          flag_order: flagV_order,

          payment_flag: value,
          payment_flag_dbfield: pay_flag_dbfield,
          payment_flag_validate: pay_flag_validate,
          payment_flag_hide: pay_flag_hide,
          payment_flag_readonly: pay_flag_readonly,
          payment_flag_required: pay_flag_required,
          payment_flag_length: pay_flag_length,
          payment_flag_script: pay_flag_script,
          payment_flag_tag: pay_flag_tag,
          payment_flag_type: pay_flag_type,
          payment_flag_order: pay_flag_order,
        },
        () => {
          this.handleinLineEdit(event);
          this.setState({ upadteableid: "", recordupdating: "" });
        }
      );
    }
    if (key === "Rate") {
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;
      if (value > 0 && value < 100000000) {
        amountV = factorV * value * unitV;

        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: Code,
            desc: name,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: value,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: factorV,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        toast.error("Invalid Value of Rate", { autoClose: 5000 });
      }
    }
    if (key === "Factor") {
      var Guid = this.state.CustomListFields[index].Guid;
      var Code = this.state.CustomListFields[index].Code;
      var name = this.state.CustomListFields[index].Desc;
      var TBA = this.state.CustomListFields[index].TBA;
      var value = event.target.innerHTML;
      if (value > 0 && value < 100000000) {
        amountV = value * rateV * unitV;

        await this.setState(
          {
            upadteableid: Guid,
            recordupdating: true,
            pmt_code: Code,
            desc: name,
            TBA: TBA,
            startDate: sDate,
            startDate_dbfield: sDate_dbfield,
            startDate_validate: sDate_validate,
            startDate_hide: sDate_hide,
            startDate_readonly: sDate_readonly,
            startDate_required: sDate_required,
            startDate_length: sDate_length,
            startDate_script: sDate_script,
            startDate_tag: sDate_tag,
            startDate_type: sDate_type,
            startDate_order: sDate_order,

            endDate: eDate,
            endDate_dbfield: eDate_dbfield,
            endDate_validate: eDate_validate,
            endDate_hide: eDate_hide,
            endDate_readonly: eDate_readonly,
            endDate_required: eDate_required,
            endDate_length: eDate_length,
            endDate_script: eDate_script,
            endDate_tag: eDate_tag,
            endDate_type: eDate_type,
            endDate_order: eDate_order,

            actionsubmission: "updated",
            unit: unitV,
            unit_dbfield: unitV_dbfield,
            unit_validate: unitV_validate,
            unit_hide: unitV_hide,
            unit_readonly: unitV_readonly,
            unit_required: unitV_required,
            unit_length: unitV_length,
            unit_script: unitV_script,
            unit_tag: unitV_tag,
            unit_type: unitV_type,
            unit_order: unitV_order,

            unit_desc: unitDes,
            unit_desc_dbfield: unitDes_dbfield,
            unit_desc_validate: unitDes_validate,
            unit_desc_hide: unitDes_hide,
            unit_desc_readonly: unitDes_readonly,
            unit_desc_required: unitDes_required,
            unit_desc_length: unitDes_length,
            unit_desc_script: unitDes_script,
            unit_desc_tag: unitDes_tag,
            unit_desc_type: unitDes_type,
            unit_desc_order: unitDes_order,

            rate: rateV,
            rate_dbfield: rateV_dbfield,
            rate_validate: rateV_validate,
            rate_hide: rateV_hide,
            rate_readonly: rateV_readonly,
            rate_required: rateV_required,
            rate_length: rateV_length,
            rate_script: rateV_script,
            rate_tag: rateV_tag,
            rate_type: rateV_type,
            rate_order: rateV_order,

            factor: value,
            factor_dbfield: factorV_dbfield,
            factor_validate: factorV_validate,
            factor_hide: factorV_hide,
            factor_readonly: factorV_readonly,
            factor_required: factorV_required,
            factor_length: factorV_length,
            factor_script: factorV_script,
            factor_tag: factorV_tag,
            factor_type: factorV_type,
            factor_order: factorV_order,

            amount: amountV,
            amount_dbfield: amountV_dbfield,
            amount_validate: amountV_validate,
            amount_hide: amountV_hide,
            amount_readonly: amountV_readonly,
            amount_required: amountV_required,
            amount_length: amountV_length,
            amount_script: amountV_script,
            amount_tag: amountV_tag,
            amount_type: amountV_type,
            amount_order: amountV_order,

            calc_weeks: calcWeeks,
            calc_weeks_dbfield: calcWeeks_dbfield,
            calc_weeks_validate: calcWeeks_validate,
            calc_weeks_hide: calcWeeks_hide,
            calc_weeks_readonly: calcWeeks_readonly,
            calc_weeks_required: calcWeeks_required,
            calc_weeks_length: calcWeeks_length,
            calc_weeks_script: calcWeeks_script,
            ecalc_weeks_tag: calcWeeks_tag,
            calc_weeks_type: calcWeeks_type,
            calc_weeks_order: calcWeeks_order,

            calc_days: calcDays,
            calc_days_dbfield: calcDays_dbfield,
            calc_days_validate: calcDays_validate,
            calc_days_hide: calcDays_hide,
            calc_days_readonly: calcDays_readonly,
            calc_days_required: calcDays_required,
            calc_days_length: calcDays_length,
            calc_days_script: calcDays_script,
            calc_days_tag: calcDays_tag,
            calc_days_type: calcDays_type,
            calc_days_order: calcDays_order,

            days_in_week: dayWeek,
            days_in_week_dbfield: dayWeek_dbfield,
            days_in_week_validate: dayWeek_validate,
            days_in_week_hide: dayWeek_hide,
            days_in_week_readonly: dayWeek_readonly,
            days_in_week_required: dayWeek_required,
            days_in_week_length: dayWeek_length,
            days_in_week_script: dayWeek_script,
            days_in_week_tag: dayWeek_tag,
            days_in_week_type: dayWeek_type,
            days_in_week_order: dayWeek_order,

            capped_amount: cap_amountV,
            capped_amount_dbfield: cap_amountV_dbfield,
            capped_amount_validate: cap_amountV_validate,
            capped_amount_hide: cap_amountV_hide,
            capped_amount_readonly: cap_amountV_readonly,
            capped_amount_required: cap_amountV_required,
            capped_amount_length: cap_amountV_length,
            capped_amount_script: cap_amountV_script,
            capped_amount_tag: cap_amountV_tag,
            capped_amount_type: cap_amountV_type,
            capped_amount_order: cap_amountV_order,

            chart_sort: chart_S,
            chart_sort_dbfield: chart_S_dbfield,
            chart_sort_validate: chart_S_validate,
            chart_sort_hide: chart_S_hide,
            chart_sort_readonly: chart_S_readonly,
            chart_sort_required: chart_S_required,
            chart_sort_length: chart_S_length,
            chart_sort_script: chart_S_script,
            chart_sort_tag: chart_S_tag,
            chart_sort_type: chart_S_type,
            chart_sort_order: chart_S_order,

            chart_code: chart_C,
            chart_code_dbfield: chart_C_dbfield,
            chart_code_validate: chart_C_validate,
            chart_code_hide: chart_C_hide,
            chart_code_readonly: chart_C_readonly,
            chart_code_required: chart_C_required,
            chart_code_length: chart_C_length,
            chart_code_script: chart_C_script,
            chart_code_tag: chart_C_tag,
            chart_code_type: chart_C_type,
            chart_code_order: chart_C_order,

            flag: flagV,
            flag_dbfield: flagV_dbfield,
            flag_validate: flagV_validate,
            flag_hide: flagV_hide,
            flag_readonly: flagV_readonly,
            flag_required: flagV_required,
            flag_length: flagV_length,
            flag_script: flagV_script,
            flag_tag: flagV_tag,
            flag_type: flagV_type,
            flag_order: flagV_order,

            payment_flag: pay_flag,
            payment_flag_dbfield: pay_flag_dbfield,
            payment_flag_validate: pay_flag_validate,
            payment_flag_hide: pay_flag_hide,
            payment_flag_readonly: pay_flag_readonly,
            payment_flag_required: pay_flag_required,
            payment_flag_length: pay_flag_length,
            payment_flag_script: pay_flag_script,
            payment_flag_tag: pay_flag_tag,
            payment_flag_type: pay_flag_type,
            payment_flag_order: pay_flag_order,
          },
          () => {
            this.handleinLineEdit(event);
            this.setState({ upadteableid: "", recordupdating: "" });
          }
        );
      } else {
        toast.error("Invalid Value Factor", { autoClose: 5000 });
      }
    }
  };
  UserInputsChngHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  onsetupModalopen = () => {
    this.setState({
      setupModalOpen: true,
    });
  };
  onsetupModalClose = () => {
    this.setState({
      setupModalOpen: false,
      //setup_chartSort: "",
      //setup_chartCode: "",
    });
  };
  onsetup_editModalopen = async () => {
    await this.setState({
      setupTrackingFieldEditModal: true,
      typeOfTrackingField: "String",
      d_value_input: "",
    });
    await this.activedefault();
  };
  onsetup_editModalclose = () => {
    this.setState({
      setupTrackingFieldEditModal: false,
      updateDataModal: false,
      tracking_order: "",
      tracking_length: "",
      tracking_prompt: "",
      d_value_input: "",
      dropdown_elements: [],
      typeOfTrackingField: "",
    });
  };
  setup_inputHandler = (e) => {
    var regEx = /[^x\-_.,()\s]/g;
    //return regEx.test(input.val());
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (name === "setup_chartSort") {
      if(regEx.test(value)){
        this.setState({
            setup_chartSortErr: "Only x, space and '- _ . , ( )' characters allowed.",
          });
        return false;
      }else{
        this.setState({
            setup_chartSortErr: false,
        });
      }
    }

    if ( name === "setup_chartCode") {
      if(regEx.test(value)){
        this.setState({
            setup_chartCodeErr: "Only x, space and '- _ . , ( )' characters allowed.",
          });
        return false;
      }else{
        this.setState({
            setup_chartCodeErr: false,
        });
      }
    }

    this.setState({[name]: value,},() => {
        this.setup_validateField(name, value);
      }
    );
  };
  setup_validateField(fieldName, value) {
    let setupErrors = this.state.setupErrors;
    let setup_chartSortValid = this.state.setup_chartSortValid;
    let setup_chartCodeValid = this.state.setup_chartCodeValid;
    switch (fieldName) {
      case "setup_chartSort":
        if (value.length <= 0) {
          // setup_chartSortValid = false;
          // setupErrors.setup_chartSortErr = "This field is required";
          this.setState({
            setup_chartSortErr: "This field is required",
          });
        } else {
          this.setState({
            setup_chartSortErr: false,
          });
        }

        break;
      case "setup_chartCode":
        if (value.length <= 0) {
          this.setState({
            setup_chartCodeErr: "This field is required",
          });

          //   setup_chartCodeValid = false;
          //   setupErrors.setup_chartCodeErr = "This field is required";
        } else {
          this.setState({
            setup_chartCodeErr: false,
          });
        }

        break;
      default:
        break;
    }
    this.setState({
      setupErrors: setupErrors,
      setup_chartSortValid: setup_chartSortValid,
      setup_chartCodeValid: setup_chartCodeValid,
    });
  }

  saveTrackingFields = () => {
    if (this.state.tracking_order === "") {
      this.setState({
        tracking_order_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_order_error: false,
      });
    }

    if ($("#typeofdefaultValue").val() === "Date") {
      if (
        this.state.trackingfiled_date === "" ||
        (this.state.trackingfiled_date === null &&
          this.state.dropdown_elements.length === 0)
      ) {
        this.setState({
          trackingfiled_date_error: true,
        });
        return;
      } else {
        this.setState({
          trackingfiled_date_error: false,
        });
      }
    }

    if (
      this.state.d_value_input === "" &&
      this.state.dropdown_elements.length === 0 &&
      $("#typeofdefaultValue").val() !== "Date"
    ) {
      this.setState({
        tracking_d_value_input_error: false,
      });
    } else {
      this.setState({
        tracking_d_value_input_error: false,
      });
    }

    if (this.state.tracking_length === "") {
      this.setState({
        tracking_length_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_length_error: false,
      });
    }

    if (this.state.tracking_prompt === "") {
      this.setState({
        tracking_prompt_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_prompt_error: false,
      });
    }

    if (
      this.state.d_value_options === "" &&
      this.state.dropdown_elements.length !== 0 &&
      $("#typeofdefaultValue").val() !== "Date"
    ) {
      this.setState({
        d_input_options_errors: true,
      });
      return false;
    } else {
      this.setState({
        d_input_options_errors: false,
      });
    }

    var checkingPresentBefore = this.state.trackingList.filter((item) => {
      if (item.Order === this.state.tracking_order) {
        return true;
      }
    });

    if (checkingPresentBefore[0]) {
      this.setState({
        order_present_before: true,
      });
    } else {
      this.setState({
        order_present_before: false,
      });

      this.setState({
        isLoading: true,
      });

      var defaultValue = "";
      var optionsValues = [];
      if (this.state.dropdown_elements.length === 0) {
        if ($("#typeofdefaultValue").val() === "Date") {
          defaultValue = moment
            .tz(
              moment(new Date(this.state.trackingfiled_date)),
              "Australia/Canberra"
            )
            .format();
        } else {
          defaultValue = this.state.d_value_input;
        }
      } else {
        defaultValue = this.state.d_value_options;
      }
      if (this.state.dropdown_elements.length !== 0) {
        optionsValues = this.state.dropdown_elements;
      } else {
        optionsValues = [];
      }

      this.setState({
        trackingList: [
          ...this.state.trackingList,
          {
            uuid: uuidv1(),
            Length: this.state.tracking_length,
            Order: this.state.tracking_order,
            Prompt: this.state.tracking_prompt,
            type:
              this.state.typeOfTrackingField === ""
                ? "String"
                : this.state.typeOfTrackingField,
            optionsValues,
            defaultValue: defaultValue === "" ? null : defaultValue,
          },
        ],
      });
      this.setState({
        isLoading: false,
        tracking_length: "",
        tracking_order: "",
        tracking_prompt: "",
        setupTrackingFieldEditModal: false,
      });
      // document.getElementById("btnclosetrackingfields").click();
    }
  };

  change_type = async (event) => {
    await this.setState({
      [event.target.name]: event.target.value,
    });
    this.activedefault();
  };
  activedefault = () => {
    if (this.state.typeOfTrackingField === "String") {
      console.log("=String", this.state.typeOfTrackingField);
      $("#d_value_input").show();
      $("#d_value_dropdown").hide();
      $("#date_input_trackingfields").hide();
      document.getElementById("d_value_input").type = "text";
    }
    if (this.state.typeOfTrackingField === "Numeric") {
      console.log("=Numeric", this.state.typeOfTrackingField);
      $("#d_value_input").show();
      $("#d_value_dropdown").hide();
      $("#date_input_trackingfields").hide();
      document.getElementById("d_value_input").type = "Number";
    }
    if (this.state.typeOfTrackingField === "Date") {
      console.log("=Date", this.state.typeOfTrackingField);
      $("#d_value_input").hide();
      $("#d_value_dropdown").hide();
      $("#date_input_trackingfields").show();
    }
    if (this.state.typeOfTrackingField === "DropList") {
      console.log("=Drop", this.state.typeOfTrackingField);
      $("#d_value_input").hide();
      $("#d_value_dropdown").show();
      $("#date_input_trackingfields").hide();
    }
  };
  handleDateChange = (date) => {
    this.setState({
      trackingfiled_date: date,
    });
  };
  openCalenderForTrackingFields = () => {
    $("#datepickerfortrackingfields").click();
  };

  openUpdateModal = async (id) => {
    console.log(">>>>", this.state.trackingList);
    var editedRow = this.state.trackingList.filter((item) => item.uuid === id);
    await this.setState({
      updateDataModal: true,
      editTrackRow: editedRow,
      setupTrackingFieldEditModal: true,
      tracking_order: editedRow[0].Order,
      tracking_length: editedRow[0].Length,
      tracking_prompt: editedRow[0].Prompt,
      d_value_input: editedRow[0].defaultValue,
      dropdown_elements: editedRow[0].optionsValues,
      typeOfTrackingField: editedRow[0].type,
    });
    console.log("+", id);
    await this.activedefault();
  };
  updateTrackingFields = () => {
    if (this.state.tracking_order === "") {
      this.setState({
        tracking_order_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_order_error: false,
      });
    }

    if (this.state.tracking_length === "") {
      this.setState({
        tracking_length_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_length_error: false,
      });
    }

    if (this.state.tracking_prompt === "") {
      this.setState({
        tracking_prompt_error: true,
      });
      return false;
    } else {
      this.setState({
        tracking_prompt_error: false,
      });
    }

    var checkingPresentBefore = this.state.trackingList.filter((item) => {
      if (
        item.Order === this.state.tracking_order &&
        item.uuid !== this.state.editTrackRow[0].uuid
      ) {
        return true;
      }
    });

    if (checkingPresentBefore[0]) {
      this.setState({
        order_present_before: true,
      });
    } else {
      this.setState({
        order_present_before: false,
      });

      this.setState({
        isLoading: true,
      });
      const trackingArray = this.state.trackingList;
      trackingArray.map((item) => {
        if (item.uuid === this.state.editTrackRow[0].uuid) {
          item.Order = this.state.tracking_order;
          item.Length = this.state.tracking_length;
          item.Prompt = this.state.tracking_prompt;
          item.defaultValue =
            this.state.d_value_input === "" ? null : this.state.d_value_input;
          item.optionsValues = this.state.dropdown_elements;
          item.type =
            this.state.typeOfTrackingField === ""
              ? "String"
              : this.state.typeOfTrackingField;
        }
      });
      this.setState({
        trackingList: trackingArray,
        isLoading: false,
        setupTrackingFieldEditModal: false,
        updateDataModal: false,
        tracking_order: "",
        tracking_length: "",
        tracking_prompt: "",
        d_value_input: "",
        dropdown_elements: [],
        typeOfTrackingField: "",
      });

      $("#approval_setup").hide();
    }
  };
  deleteTrackingObject = (id) => {
    this.setState({
      isLoading: true,
    });
    this.setState({
      trackingList: this.state.trackingList.filter((item) => item.uuid !== id),
    });
    this.setState({
      isLoading: false,
    });
  };
  ondrop_listModalOpen = () => {
    this.setState({ drop_listModal: true });
  };
  ondrop_listModalClose = () => {
    this.setState({ drop_listModal: false });
  };

  onDropDownValuesSave = () => {
    if (this.state.options === "") {
      this.setState({
        options_error: true,
      });
      return;
    } else {
      this.setState({
        options_error: false,
      });
    }
    if (this.state.values === "") {
      this.setState({
        values_error: true,
      });
    } else {
      this.setState({
        values_error: false,
      });
      this.setState({
        dropdown_elements: [
          ...this.state.dropdown_elements,
          {
            key: uuidv1(),
            option: this.state.options,
            value: this.state.values,
          },
        ],
      });

      this.setState({
        options: "",
        values: "",
      });
    }

    // $('#approval_setup_2').hide();
  };
  deleteOptionValue = (key) => {
    this.setState({
      dropdown_elements: this.state.dropdown_elements.filter(
        (item) => item.key !== key
      ),
    });
  };
  editDropListButtonClicked = (key) => {
    const editedRow = this.state.dropdown_elements.filter(
      (item) => item.key === key
    );
    this.setState({
      options: editedRow[0].option,
      values: editedRow[0].value,
      editDropDown: true,
      editableOptionKey: editedRow[0].key,
    });
  };
  cancel_update_option = () => {
    this.setState({
      options: "",
      values: "",
      editDropDown: false,
      editableOptionKey: "",
    });
  };
  onUpdateDropDownValues = () => {
    const optionsArray = [...this.state.dropdown_elements];
    const newArary = optionsArray.map((item) => {
      if (item.key === this.state.editableOptionKey) {
        item.key = this.state.editableOptionKey;
        item.option = this.state.options;
        item.value = this.state.values;
      }
      return item;
    });
    this.setState({
      dropdown_elements: newArary,
      editDropDown: false,
      options: "",
      values: "",
    });
  };

  handleSubmitSetupForm = async () => {
    if (
      this.state.setup_chartCode !== "" &&
      this.state.setup_chartSort !== ""
    ) {
      this.setState({ isLoading: true });
      try {
        var res = await this.props.postRequest("/setup/update", {
          upadteableid: this.state.setup_data.Guid,
          Codes: {
            chart_code: this.state.setup_chartCode,
            chart_sort: this.state.setup_chartSort,
          },
          TrackingFields: this.state.trackingList,
        });
        if (res.status) {
          this.onsetupModalClose();
          this.setState({ isLoading: false });
          toast.success("Setup updated successfully.", {
            autoClose: 5000,
          });
        } else {
          console.log("update setup response=>", res);
          toast.error(res.error, { autoClose: 5000 });
          this.setState({ isLoading: false });
        }
      } catch (err) {
        console.log("update setup error=>", err);
        toast.error(res.message, { autoClose: 5000 });
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({ setup_chartSortErr: true, setup_chartCodeErr: true });
    }
  };

  render() {
    return (
      <div className="CustomFieldsList">
        <Header
          pageHeading=""
          hideHomeButton="0"
          props={this.props}
          isLoading={this.state.isLoading}
        />
        <div className="clearfix"></div>
        <div className="col-xs-12 col-sm-9 col-md-10 pull-right p0 top_mrg_general top_mrg_general_custom">
          <div className="">
            <div className="col-sm-12 col-md-12 col-lg-10 col-lg-offset-1 general_setting_hd">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div className="clear10"></div>
                <a href={null}>
                  <button
                    type="button"
                    className="btn btn-primary pull-right plus_icon_table btn_plus_cusotm btn_custom_list customfieldlist_btn_plus_cusotm "
                    onClick={(event) => this.onad_ModalOpen()}
                  >
                    +
                  </button>
                </a>
                <button
                  type="button"
                  className="btn btn-primary pull-right plus_icon_table btn_plus_cusotm btn_custom_list customfieldlist_btn_plus_cusotm s_button"
                  onClick={(event) => this.onsetupModalopen()}
                >
                  <img src={settingIcon} alt="" />
                </button>
                <div className="clearfix"></div>

                <div className="overflow_scroll_sm_list">
                  <table
                    width="100%"
                    className="table  timecard_table custome_lsit_field_table customfieldslist_noBorder"
                  >
                    <thead>
                      <tr>
                        <th width="7%" align="center" valign="middle">
                          PmtCode
                        </th>
                        <th width="8%" align="center" valign="middle">
                          Desc
                        </th>
                        <th width="4%" align="center" valign="middle">
                          Units
                        </th>
                        <th width="6%" align="center" valign="middle">
                          UnitsDesc
                        </th>
                        <th width="5%" align="center" valign="middle">
                          Rate
                        </th>
                        <th width="5%" align="center" valign="middle">
                          Factor
                        </th>
                        <th width="5%" align="center" valign="middle">
                          Amount
                        </th>
                        <th width="5%" align="center" valign="middle">
                          Capped
                        </th>
                        <th width="6%" align="center" valign="middle">
                          DateFrom
                        </th>
                        <th width="6%" align="center" valign="middle">
                          DateTo
                        </th>
                        <th width="6%" align="center" valign="middle">
                          ChartSort
                        </th>
                        <th width="6%" align="center" valign="middle">
                          ChartCode
                        </th>
                        <th width="5%" align="center" valign="middle">
                          TrackingField
                        </th>
                        <th width="6%" align="center" valign="middle">
                          PaymentFlag
                        </th>
                        <th width="6%" align="center" valign="middle">
                          TBA
                        </th>

                        <th width="20%" align="center" valign="middle">
                          &nbsp;
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.CustomListFields.map((listValue, index) => {
                        // console.log("=>TBA", listValue);
                        var customFieldsarray = listValue.CustomFields;
                        customFieldsarray.map((val, key) => {
                          if (val.Desc === "Units") {
                            listValue.Units = val.Value;
                            listValue.UnitsHide = val.Hide;
                          }
                          if (val.Desc === "Unit Desc") {
                            listValue.UnitsDesc = val.Value;
                            listValue.UnitsDescHide = val.Hide;
                          }
                          if (val.Desc === "Rate") {
                            listValue.Rate = val.Value;
                            listValue.RateHide = val.Hide;
                          }
                          if (val.Desc === "Factor") {
                            listValue.Factor = val.Value;
                            listValue.FactorHide = val.Hide;
                          }
                          if (val.Desc === "Amount") {
                            listValue.Amount = val.Value;
                            listValue.AmountHide = val.Hide;
                          }
                          if (val.Desc === "Capped Amount") {
                            listValue.Capped = val.Value;
                            listValue.CappedHide = val.Hide;
                          }
                          if (val.Desc === "Date From:") {
                            var datefromall = val.Value;
                            if (datefromall !== null) {
                              var date = new Date(datefromall);
                              listValue.DateFrom = moment(date).format(
                                "DD/MM/YYYY"
                              );
                              listValue.DateFromHide = val.Hide;
                            } else {
                              listValue.DateFrom = val.Value;
                              listValue.DateFromHide = val.Hide;
                            }
                          }
                          if (val.Desc === "Date To:") {
                            var datetoall = val.Value;
                            if (datetoall !== null) {
                              var date = new Date(datetoall);
                              listValue.DateTo = moment(date).format(
                                "DD/MM/YYYY"
                              );
                              listValue.DateToHide = val.Hide;
                            } else {
                              listValue.DateTo = val.Value;
                              listValue.DateToHide = val.Hide;
                            }
                          }
                          if (val.Desc === "Chart Sort") {
                            listValue.ChartSort = val.Value;
                            listValue.ChartSortHide = val.Hide;
                          }
                          if (val.Desc === "Chart Code") {
                            listValue.ChartCode = val.Value;
                            listValue.ChartCodeHide = val.Hide;
                          }
                          if (val.Desc === "Flag:") {
                            listValue.Flag = val.Value;
                            listValue.FlagHide = val.Hide;
                          }
                          if (val.Desc === "Payment Flag:") {
                            listValue.PaymentFlag = val.Value;
                            listValue.PaymentFlagHide = val.Hide;
                            console.log("=>Hid", listValue.PaymentFlagHide);
                          }
                          return null;
                        });
                        return (
                          <tr key={index}>
                            <td
                              align="center"
                              valign="middle"
                              contentEditable="true"
                              onBlur={(event) =>
                                this.updateCellsvalue(event, index, "Code")
                              }
                            >
                              {listValue.Code}
                            </td>
                            <td
                              align="center"
                              valign="middle"
                              contentEditable="true"
                              onBlur={(event) =>
                                this.updateCellsvalue(event, index, "Name")
                              }
                            >
                              {listValue.Desc}
                            </td>
                            {!listValue.UnitsHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) => {
                                  this.amount_calculation(
                                    listValue.Factor,
                                    listValue.Rate,
                                    event.target.innerHTML
                                  );

                                  this.updateCellsvalue(event, index, "Unit");
                                }}
                              >
                                {listValue.Units ? listValue.Units : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.UnitsDescHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(
                                    event,
                                    index,
                                    "UnitDesc"
                                  )
                                }
                              >
                                {listValue.UnitsDesc
                                  ? listValue.UnitsDesc
                                  : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.RateHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(event, index, "Rate")
                                }
                              >
                                {listValue.Rate ? listValue.Rate : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}{" "}
                            {!listValue.FactorHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(event, index, "Factor")
                                }
                              >
                                {listValue.Factor ? listValue.Factor : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.AmountHide ? (
                              <td align="center" valign="middle">
                                {listValue.Amount ? listValue.Amount : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.CappedHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(
                                    event,
                                    index,
                                    "CappedAmount"
                                  )
                                }
                              >
                                {listValue.Capped ? listValue.Capped : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}{" "}
                            {!listValue.DateFromHide ? (
                              listValue.Amount > 0 ? (
                                <td
                                  align="center"
                                  valign="middle"
                                  className="CustomFieldList_date"
                                >
                                  <DatePicker
                                    dateFormat="DD/MM/YYYY"
                                    placeholderText={
                                      listValue.DateFrom
                                        ? listValue.DateFrom
                                        : "NA"
                                    }
                                    onChange={(s_date) => {
                                      this.updateCellsvalue(
                                        s_date,
                                        index,
                                        "StartDate"
                                      );
                                    }}
                                  />

                                  {/* {listValue.DateFrom ? listValue.DateFrom : "NA"} */}
                                </td>
                              ) : (
                                <td align="center">----</td>
                              )
                            ) : (
                              <td align="center">----</td>
                            )}
                            {listValue.TBA !== "checked" ||
                            listValue.TBA === null ? (
                              !listValue.DateToHide ? (
                                listValue.Amount > 0 ? (
                                  <td
                                    align="center"
                                    valign="middle"
                                    className="CustomFieldList_date"
                                  >
                                    <DatePicker
                                      dateFormat="DD/MM/YYYY"
                                      placeholderText={
                                        listValue.DateTo
                                          ? listValue.DateTo
                                          : "NA"
                                      }
                                      onChange={(e_date) => {
                                        this.updateCellsvalue(
                                          e_date,
                                          index,
                                          "EndDate"
                                        );
                                      }}
                                    />

                                    {/* {listValue.DateTo ? listValue.DateTo : "NA"} */}
                                  </td>
                                ) : (
                                  <td align="center">----</td>
                                )
                              ) : (
                                <td align="center">----</td>
                              )
                            ) : (
                              <td align="center">TBA</td>
                            )}{" "}
                            {!listValue.ChartSortHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(
                                    event,
                                    index,
                                    "ChartSort"
                                  )
                                }
                              >
                                {listValue.ChartSort
                                  ? listValue.ChartSort
                                  : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.ChartCodeHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(
                                    event,
                                    index,
                                    "ChartCode"
                                  )
                                }
                              >
                                {listValue.ChartCode
                                  ? listValue.ChartCode
                                  : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.FlagHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(event, index, "Flag")
                                }
                              >
                                {listValue.Flag ? listValue.Flag : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}
                            {!listValue.PaymentFlagHide ? (
                              <td
                                align="center"
                                valign="middle"
                                contentEditable="true"
                                onBlur={(event) =>
                                  this.updateCellsvalue(
                                    event,
                                    index,
                                    "PaymentFlag"
                                  )
                                }
                              >
                                {listValue.PaymentFlag
                                  ? listValue.PaymentFlag
                                  : "NA"}
                              </td>
                            ) : (
                              <td align="center">----</td>
                            )}{" "}
                            <td align="center" valign="middle">
                              <div className="col-xs-12 col-sm-8 col-md-8 pad-0">
                                <label className="check_box_pop">
                                  <input
                                    type="checkbox"
                                    value={listValue.TBA}
                                    checked={listValue.TBA}
                                    onChange={(event) =>
                                      this.updateCellsvalue(event, index, "TBA")
                                    }
                                  />
                                  <span className="checkmark report_checkmark new-chekbox"></span>
                                </label>
                              </div>
                            </td>
                            <td align="center" valign="middle">
                              <div className="col-sm-4  col-xs-6 p0 pull-right text-center timecard_dele pull-right">
                                <a
                                  href={null}
                                  onClick={this.handleDeleteCustomList(
                                    listValue.Guid
                                  )}
                                  className="cursorPointer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="1700 296 15 19.286"
                                  >
                                    <path
                                      id="ic_delete_24px5"
                                      className="cls-1"
                                      d="M6.071,20.143a2.149,2.149,0,0,0,2.143,2.143h8.571a2.149,2.149,0,0,0,2.143-2.143V7.286H6.071ZM20,4.071H16.25L15.179,3H9.821L8.75,4.071H5V6.214H20Z"
                                      transform="translate(1695 293)"
                                    />
                                  </svg>
                                </a>
                              </div>
                              <div className="col-sm-4  col-xs-6 p0 text-center timecard_edit6 pull-right">
                                <a
                                  href={null}
                                  onClick={this.handleUpdateCustomList(
                                    listValue.Guid
                                  )}
                                  className="cursorPointer"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="1656.776 299 17.515 18.003"
                                  >
                                    <path
                                      id="ic_create_24px5"
                                      className="cls-1"
                                      d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                      transform="translate(1653.776 296.002)"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="clear10"></div>
          </div>
        </div>
        <div className="clear10"></div>
        <Modal
          show={this.state.ad_modalOpen}
          onHide={(event) => this.onad_ModalClose()}
          id="addCustomFieldlistmodal"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onad_ModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Custom List Code {this.state.recordupdating ? "Update" : ""}{" "}
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist modal_pop_list_scroll customfieldslist_padding">
            <div className="col-sm-12">
              NOTE: Drag fields to change order in form and list.
              <div className="clear20"></div>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="col-sm-12 p0 mrg_bot_custom10">
                <div
                  id="pmt_code"
                  className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop"
                >
                  Pmt Code:
                </div>
                <div className="col-xs-10 col-sm-7 col-md-7">
                  <input
                    name="pmt_code"
                    type="text"
                    value={this.state.pmt_code}
                    onChange={(event) => this.handleUserInput(event)}
                  />
                  <p
                    className={
                      "error validation " +
                      (this.state.formErrors.pmt_code ? "" : "displayNone")
                    }
                  >
                    {this.state.formErrors.pmt_code}
                  </p>
                </div>
              </div>
              <div className="col-sm-12 p0 mrg_bot_custom10">
                <div
                  id="desc"
                  className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop"
                >
                  Description:
                </div>
                <div className="col-xs-10 col-sm-7 col-md-7">
                  <input
                    name="desc"
                    value={this.state.desc}
                    onChange={(event) => this.handleUserInput(event)}
                    type="text"
                  />
                  <p
                    className={
                      "error validation " +
                      (this.state.formErrors.desc ? "" : "displayNone")
                    }
                  >
                    {this.state.formErrors.desc}
                  </p>
                </div>
              </div>
              <div className="col-sm-12 p0 mrg_bot_custom10">
                <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                  TBA:
                </div>
                <div className="col-xs-12 col-sm-8 col-md-8">
                  <label className="check_box_pop">
                    <input
                      type="checkbox"
                      name="TBA"
                      value={this.state.TBA}
                      checked={this.state.TBA}
                      onChange={(event) => this.handleUserInputCheckbox(event)}
                    />
                    <span className="checkmark report_checkmark"></span>
                  </label>
                </div>
              </div>
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="tagsForm">
                  {(provided, snapshot) => (
                    <div
                      id="tagsForm"
                      className="sortable"
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      <div className="clear10"></div>
                      {this.state.listHandler.CustomFields.map(
                        (field, index) => {
                          if (!field.Hide) {
                            if (field.Desc === "Units") {
                              if (!this.state.unit_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="unit"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Unit:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="unit"
                                            value={this.state.unit}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="number"
                                            min="0"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.unit
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.unit}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onUnitModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }

                            if (field.Desc === "Unit Desc") {
                              if (!this.state.unit_desc_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="unit_desc"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Unit Desc:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="unit_desc"
                                            value={this.state.unit_desc}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="text"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.unit_desc
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.unit_desc}
                                          </p>
                                        </div>
                                        <div class="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onUnitDescModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Rate") {
                              if (!this.state.rate_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="rate"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Rate:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="rate"
                                            value={this.state.rate}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            max="1000000000"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.rate
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.rate}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onRateModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return " ";
                              }
                            }
                            if (field.Desc === "Factor") {
                              if (!this.state.factor_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="factor"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Factor:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="factor"
                                            value={this.state.factor}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="number"
                                            step="0.01"
                                            min="0"
                                            max="1000000000"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.factor
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.factor}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onFactorModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Amount") {
                              if (!this.state.amount_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="amount"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Amount:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="amount"
                                            value={this.state.amount}
                                            type="text"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.amount
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.amount}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onAmountModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }

                            if (field.Desc === "Capped Amount") {
                              if (!this.state.capped_amount_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="capped_amount"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Capped Amount:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="capped_amount"
                                            value={this.state.capped_amount}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="number"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors
                                                .capped_amount
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {
                                              this.state.formErrors
                                                .capped_amount
                                            }
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onCappedModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Days in Week") {
                              if (!this.state.days_in_week_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="days_in_week"
                                          className="col-xs-12 col-sm-4 col-md-4"
                                        >
                                          Days in Week:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="days_in_week"
                                            value={this.state.days_in_week}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="number"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors
                                                .days_in_week
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.days_in_week}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onDaysInWeekModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Date From:") {
                              if (!this.state.startDate_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        <div
                                          id="startDate"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Date From:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 form__date--picker ">
                                          <div className="col-xs-8 col-sm-8 p0">
                                            <DatePicker
                                              id="showDateFrom"
                                              dateFormat="DD/MM/YYYY"
                                              defaultValue=""
                                              selected={
                                                this.state.datePickerDisable
                                                  ? ""
                                                  : this.state.startDate
                                              }
                                              onChange={this.handleChange.bind(
                                                this
                                              )}
                                              disabled={
                                                this.state.datePickerDisable
                                              }
                                            />
                                          </div>
                                          <div className="Svg--icons--picker ">
                                            <svg
                                              className="cursorPointer"
                                              onClick={(event) =>
                                                this.showDateFrom()
                                              }
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="2936.352 349.176 18.501 23.145"
                                            >
                                              <a
                                                href={null}
                                                class="svg__color--blue"
                                              >
                                                <path
                                                  id="ic_date_range_24px"
                                                  className="cls-1"
                                                  d="M9.167,12.415H7.111V14.73H9.167Zm4.111,0H11.223V14.73h2.056Zm4.111,0H15.334V14.73H17.39Zm2.056-8.1H18.418V2H16.362V4.314H8.139V2H6.084V4.314H5.056A2.188,2.188,0,0,0,3.01,6.629L3,22.83a2.2,2.2,0,0,0,2.056,2.314h14.39A2.2,2.2,0,0,0,21.5,22.83V6.629A2.2,2.2,0,0,0,19.446,4.314Zm0,18.516H5.056V10.1h14.39Z"
                                                  transform="translate(2933.352 347.176)"
                                                ></path>
                                              </a>
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onDateFromModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }

                            if (field.Desc === "Date To:") {
                              if (!this.state.endDate_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props form__display--between"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="endDate"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Date To:
                                        </div>
                                        {this.state.TBA ? (
                                          <div className="col-xs-12 col-sm-4 col-md-4 tba-box ">
                                            TBA
                                          </div>
                                        ) : (
                                          <React.Fragment>
                                            <div className="col-xs-10 col-sm-7 col-md-7 form__date--picker">
                                              <div className="col-xs-8 col-sm-8 p0">
                                                <DatePicker
                                                  id="showDateTo"
                                                  dateFormat="DD/MM/YYYY"
                                                  selected={
                                                    this.state.datePickerDisable
                                                      ? ""
                                                      : this.state.endDate
                                                  }
                                                  onChange={this.handleChangeTo.bind(
                                                    this
                                                  )}
                                                  disabled={
                                                    this.state.datePickerDisable
                                                  }
                                                />
                                              </div>
                                              <div className="Svg--icons--picker ">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  className="cursorPointer"
                                                  onClick={(event) =>
                                                    this.showDateTo()
                                                  }
                                                  viewBox="2936.352 349.176 18.501 23.145"
                                                >
                                                  <a
                                                    href={null}
                                                    class="svg__color--blue"
                                                  >
                                                    <path
                                                      id="ic_date_range_24px"
                                                      className="cls-1"
                                                      d="M9.167,12.415H7.111V14.73H9.167Zm4.111,0H11.223V14.73h2.056Zm4.111,0H15.334V14.73H17.39Zm2.056-8.1H18.418V2H16.362V4.314H8.139V2H6.084V4.314H5.056A2.188,2.188,0,0,0,3.01,6.629L3,22.83a2.2,2.2,0,0,0,2.056,2.314h14.39A2.2,2.2,0,0,0,21.5,22.83V6.629A2.2,2.2,0,0,0,19.446,4.314Zm0,18.516H5.056V10.1h14.39Z"
                                                      transform="translate(2933.352 347.176)"
                                                    ></path>
                                                  </a>
                                                </svg>
                                              </div>
                                            </div>
                                            <div className="col-xs-2 col-sm-1 col-md-1">
                                              <button
                                                type="button"
                                                onClick={(event) =>
                                                  this.onDateToModalOpen()
                                                }
                                                className="pen_custom_list_pop customfieldlist_OutlineNone "
                                              >
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  viewBox="1656.776 299 17.515 18.003"
                                                >
                                                  <path
                                                    id="ic_create_24px"
                                                    className="cls-1"
                                                    d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                    transform="translate(1653.776 296.002)"
                                                  ></path>
                                                </svg>
                                              </button>
                                            </div>
                                          </React.Fragment>
                                        )}
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Chart Sort") {
                              if (!this.state.chart_sort_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="chart_sort"
                                          className="col-xs-12 col-sm-4 col-md-4"
                                        >
                                          Chart Sort:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <InputMask
                                            mask={this.state.setup_chartSort.replace(/x/g, "*")}
                                            maskChar={null}
                                            type="text"
                                            name="chart_sort"
                                            value={this.state.chart_sort}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.chart_sort
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.chart_sort}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            onClick={(event) =>
                                              this.onChartModalOpen()
                                            }
                                            type="button"
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Chart Code") {
                              if (!this.state.chart_code_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="chart_code"
                                          className="col-xs-12 col-sm-4 col-md-4"
                                        >
                                          Chart Code:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <InputMask
                                            mask={this.state.setup_chartCode.replace(/x/g, "*")}
                                            maskChar={null}
                                            type="text"
                                            name="chart_code"
                                            value={this.state.chart_code}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.chart_code
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.chart_code}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onChartCodeModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Flag:") {
                              if (!this.state.flag_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="flag"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Tracking Field:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="flag"
                                            value={this.state.flag}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="text"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors.flag
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.flag}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onFlagModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Payment Flag:") {
                              if (!this.state.payment_flag_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="payment_flag"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Payment Flag:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="payment_flag"
                                            value={this.state.payment_flag}
                                            onChange={(event) =>
                                              this.handleUserInput(event)
                                            }
                                            type="text"
                                          />
                                          <p
                                            className={
                                              "error validation " +
                                              (this.state.formErrors
                                                .payment_flag
                                                ? ""
                                                : "displayNone")
                                            }
                                          >
                                            {this.state.formErrors.payment_flag}
                                          </p>
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onPaymentFlagModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Calc Days") {
                              if (!this.state.calc_days_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="calc_days"
                                          className="col-xs-12 col-sm-4 col-md-4 "
                                        >
                                          Calc Days:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="calc_days"
                                            value={this.state.calc_days}
                                            type="text"
                                            readOnly={true}
                                          />
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1 ">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onCalcDaysModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                            if (field.Desc === "Calc Weeks") {
                              if (!this.state.calc_weeks_hide) {
                                return (
                                  <Draggable
                                    key={field.Desc}
                                    draggableId={field.Desc}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        className="form__display--props"
                                        // className="col-sm-12 "
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                      >
                                        {" "}
                                        <div
                                          id="calc_weeks"
                                          className="col-xs-12 col-sm-4 col-md-4"
                                        >
                                          Calc Weeks:
                                        </div>
                                        <div className="col-xs-10 col-sm-7 col-md-7 ">
                                          <input
                                            name="calc_weeks"
                                            value={this.state.calc_weeks}
                                            type="text"
                                            readOnly={true}
                                          />
                                        </div>
                                        <div className="col-xs-2 col-sm-1 col-md-1 ">
                                          <button
                                            type="button"
                                            onClick={(event) =>
                                              this.onCalcWeeksModalOpen()
                                            }
                                            className="pen_custom_list_pop customfieldlist_OutlineNone "
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="1656.776 299 17.515 18.003"
                                            >
                                              <path
                                                id="ic_create_24px"
                                                className="cls-1"
                                                d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                transform="translate(1653.776 296.002)"
                                              ></path>
                                            </svg>
                                          </button>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              } else {
                                return "";
                              }
                            }
                          }
                        }
                      )}
                      {provided.placeholder}
                      <div className="clear5"></div>
                    </div>
                  )}
                </Droppable>
                <div className="panel-heading panel_width exclude">
                  <h4 className="panel-title">
                    <a
                      className="accordion-toggle collapsed text_change"
                      data-toggle="collapse"
                      data-parent="#sortable"
                      href="#hide_detail"
                    >
                      More Detail
                    </a>
                  </h4>
                </div>
                <Droppable droppableId="hide_detail">
                  {(provided, snapshot) => (
                    <div
                      id="hide_detail"
                      className="panel-collapse collapse "
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      <div className="clear10"></div>
                      <div className="panel-body p0 ">
                        {this.state.listHandler.CustomFields.map(
                          (field, index) => {
                            if (field.Hide) {
                              if (field.Desc === "Units") {
                                if (this.state.unit_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="unit"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Unit:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="unit"
                                              value={this.state.unit}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="number"
                                              min="0"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.unit
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.unit}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onUnitModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }

                              if (field.Desc === "Unit Desc") {
                                if (this.state.unit_desc_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="unit_desc"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Unit Desc:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="unit_desc"
                                              value={this.state.unit_desc}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="text"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.unit_desc
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.unit_desc}
                                            </p>
                                          </div>
                                          <div class="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onUnitDescModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Rate") {
                                if (this.state.rate_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="rate"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Rate:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="rate"
                                              value={this.state.rate}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              max="1000000000"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.rate
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.rate}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onRateModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return " ";
                                }
                              }
                              if (field.Desc === "Factor") {
                                if (this.state.factor_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="factor"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Factor:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="factor"
                                              value={this.state.factor}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="number"
                                              step="0.01"
                                              min="0"
                                              max="1000000000"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.factor
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.factor}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onFactorModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone customfielddlist_pen_custom_list_pop"
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Amount") {
                                if (this.state.amount_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="amount"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Amount:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="amount"
                                              value={this.state.amount}
                                              type="text"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.amount
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.amount}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onAmountModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }

                              if (field.Desc === "Capped Amount") {
                                if (this.state.capped_amount_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="capped_amount"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Capped Amount:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="capped_amount"
                                              value={this.state.capped_amount}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="number"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors
                                                  .capped_amount
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {
                                                this.state.formErrors
                                                  .capped_amount
                                              }
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onCappedModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Days in Week") {
                                if (this.state.days_in_week_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="days_in_week"
                                            className="col-xs-12 col-sm-4 col-md-4"
                                          >
                                            Days in Week:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="days_in_week"
                                              value={this.state.days_in_week}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="number"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors
                                                  .days_in_week
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {
                                                this.state.formErrors
                                                  .days_in_week
                                              }
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onDaysInWeekModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Date From:") {
                                if (this.state.startDate_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          <div
                                            id="startDate"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Date From:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 form__date--picker ">
                                            <div className="col-xs-8 col-sm-8 p0">
                                              <DatePicker
                                                id="showDateFrom"
                                                dateFormat="DD/MM/YYYY"
                                                defaultValue=""
                                                selected={
                                                  this.state.datePickerDisable
                                                    ? ""
                                                    : this.state.startDate
                                                }
                                                onChange={this.handleChange.bind(
                                                  this
                                                )}
                                                disabled={
                                                  this.state.datePickerDisable
                                                }
                                              />
                                            </div>
                                            <div className="Svg--icons--picker ">
                                              <svg
                                                className="cursorPointer"
                                                onClick={(event) =>
                                                  this.showDateFrom()
                                                }
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="2936.352 349.176 18.501 23.145"
                                              >
                                                <a
                                                  href={null}
                                                  class="svg__color--blue"
                                                >
                                                  <path
                                                    id="ic_date_range_24px"
                                                    className="cls-1"
                                                    d="M9.167,12.415H7.111V14.73H9.167Zm4.111,0H11.223V14.73h2.056Zm4.111,0H15.334V14.73H17.39Zm2.056-8.1H18.418V2H16.362V4.314H8.139V2H6.084V4.314H5.056A2.188,2.188,0,0,0,3.01,6.629L3,22.83a2.2,2.2,0,0,0,2.056,2.314h14.39A2.2,2.2,0,0,0,21.5,22.83V6.629A2.2,2.2,0,0,0,19.446,4.314Zm0,18.516H5.056V10.1h14.39Z"
                                                    transform="translate(2933.352 347.176)"
                                                  ></path>
                                                </a>
                                              </svg>
                                            </div>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onDateFromModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }

                              if (field.Desc === "Date To:") {
                                if (this.state.endDate_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props form__display--between"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="endDate"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Date To:
                                          </div>
                                          {this.state.TBA ? (
                                            <div className="col-xs-12 col-sm-4 col-md-4 tba-box">
                                              TBA
                                            </div>
                                          ) : (
                                            <React.Fragment>
                                              <div className="col-xs-10 col-sm-7 col-md-7 form__date--picker">
                                                <div className="col-xs-8 col-sm-8 p0">
                                                  <DatePicker
                                                    id="showDateTo"
                                                    dateFormat="DD/MM/YYYY"
                                                    selected={
                                                      this.state
                                                        .datePickerDisable
                                                        ? ""
                                                        : this.state.endDate
                                                    }
                                                    onChange={this.handleChangeTo.bind(
                                                      this
                                                    )}
                                                    disabled={
                                                      this.state
                                                        .datePickerDisable
                                                    }
                                                  />
                                                </div>
                                                <div className="Svg--icons--picker ">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="cursorPointer"
                                                    onClick={(event) =>
                                                      this.showDateTo()
                                                    }
                                                    viewBox="2936.352 349.176 18.501 23.145"
                                                  >
                                                    <a
                                                      href={null}
                                                      class="svg__color--blue"
                                                    >
                                                      <path
                                                        id="ic_date_range_24px"
                                                        className="cls-1"
                                                        d="M9.167,12.415H7.111V14.73H9.167Zm4.111,0H11.223V14.73h2.056Zm4.111,0H15.334V14.73H17.39Zm2.056-8.1H18.418V2H16.362V4.314H8.139V2H6.084V4.314H5.056A2.188,2.188,0,0,0,3.01,6.629L3,22.83a2.2,2.2,0,0,0,2.056,2.314h14.39A2.2,2.2,0,0,0,21.5,22.83V6.629A2.2,2.2,0,0,0,19.446,4.314Zm0,18.516H5.056V10.1h14.39Z"
                                                        transform="translate(2933.352 347.176)"
                                                      ></path>
                                                    </a>
                                                  </svg>
                                                </div>
                                              </div>
                                              <div className="col-xs-2 col-sm-1 col-md-1">
                                                <button
                                                  type="button"
                                                  onClick={(event) =>
                                                    this.onDateToModalOpen()
                                                  }
                                                  className="pen_custom_list_pop customfieldlist_OutlineNone "
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="1656.776 299 17.515 18.003"
                                                  >
                                                    <path
                                                      id="ic_create_24px"
                                                      className="cls-1"
                                                      d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                      transform="translate(1653.776 296.002)"
                                                    ></path>
                                                  </svg>
                                                </button>
                                              </div>
                                            </React.Fragment>
                                          )}
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Chart Sort") {
                                if (this.state.chart_sort_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="chart_sort"
                                            className="col-xs-12 col-sm-4 col-md-4"
                                          >
                                            Chart Sort:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <InputMask
                                              mask={this.state.setup_chartSort.replace(/x/g, "*")}
                                              maskChar={null}
                                              type="text"
                                              name="chart_sort"
                                              value={this.state.chart_sort}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors
                                                  .chart_sort
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.chart_sort}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              onClick={(event) =>
                                                this.onChartModalOpen()
                                              }
                                              type="button"
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Chart Code") {
                                if (this.state.chart_code_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="chart_code"
                                            className="col-xs-12 col-sm-4 col-md-4"
                                          >
                                            Chart Code:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <InputMask
                                              mask={this.state.setup_chartCode.replace(/x/g, "*")}
                                              maskChar={null}
                                              type="text"
                                              name="chart_code"
                                              value={this.state.chart_code}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors
                                                  .chart_code
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.chart_code}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onChartCodeModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Flag:") {
                                if (this.state.flag_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="flag"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Tracking Field:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="flag"
                                              value={this.state.flag}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="text"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors.flag
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {this.state.formErrors.flag}
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onFlagModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Payment Flag:") {
                                if (this.state.payment_flag_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="payment_flag"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Payment Flag:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="payment_flag"
                                              value={this.state.payment_flag}
                                              onChange={(event) =>
                                                this.handleUserInput(event)
                                              }
                                              type="text"
                                            />
                                            <p
                                              className={
                                                "error validation " +
                                                (this.state.formErrors
                                                  .payment_flag
                                                  ? ""
                                                  : "displayNone")
                                              }
                                            >
                                              {
                                                this.state.formErrors
                                                  .payment_flag
                                              }
                                            </p>
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onPaymentFlagModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Calc Days") {
                                if (this.state.calc_days_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="calc_days"
                                            className="col-xs-12 col-sm-4 col-md-4 "
                                          >
                                            Calc Days:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="calc_days"
                                              value={this.state.calc_days}
                                              type="text"
                                              readOnly={true}
                                            />
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1 ">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onCalcDaysModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                              if (field.Desc === "Calc Weeks") {
                                if (this.state.calc_weeks_hide) {
                                  return (
                                    <Draggable
                                      key={field.Desc}
                                      draggableId={field.Desc}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <div
                                          className="form__display--props"
                                          // className="col-sm-12 "
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                        >
                                          {" "}
                                          <div
                                            id="calc_weeks"
                                            className="col-xs-12 col-sm-4 col-md-4"
                                          >
                                            Calc Weeks:
                                          </div>
                                          <div className="col-xs-10 col-sm-7 col-md-7 ">
                                            <input
                                              name="calc_weeks"
                                              value={this.state.calc_weeks}
                                              type="text"
                                              readOnly={true}
                                            />
                                          </div>
                                          <div className="col-xs-2 col-sm-1 col-md-1 ">
                                            <button
                                              type="button"
                                              onClick={(event) =>
                                                this.onCalcWeeksModalOpen()
                                              }
                                              className="pen_custom_list_pop customfieldlist_OutlineNone "
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="1656.776 299 17.515 18.003"
                                              >
                                                <path
                                                  id="ic_create_24px"
                                                  className="cls-1"
                                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                                  transform="translate(1653.776 296.002)"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  );
                                } else {
                                  return "";
                                }
                              }
                            }
                          }
                        )}
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

              <div className="clear30"></div>
              <div className="col-sm-6">
                <div className="btn_cance_save">
                  <button
                    type="submit"
                    className="btn_save_pro"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={(event) => this.onad_ModalClose()}
                    className="btn_cancel_pro"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
            <div className="clear20"></div>
          </div>
        </Modal>

        <Modal
          show={this.state.modalOpen}
          onHide={(event) => this.onUnitModalClose()}
          id="myModal2"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onUnitModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Unit Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_dbfield"
                  value={this.state.unit_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_validate"
                  value={this.state.unit_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_length"
                  value={this.state.unit_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_script"
                  value={this.state.unit_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="unit_type"
                  value={this.state.unit_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_tag"
                  type="text"
                  value={this.state.unit_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_hide"
                    value={this.state.unit_hide}
                    checked={this.state.unit_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_readonly"
                    value={this.state.unit_readonly}
                    checked={this.state.unit_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_required"
                    value={this.state.unit_required}
                    checked={this.state.unit_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="unitModal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onUnitModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.UnitDescModalOpen}
          onHide={(event) => this.onUnitDescModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onUnitDescModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Unit Desc Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_desc_dbfield"
                  value={this.state.unit_desc_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_desc_validate"
                  value={this.state.unit_desc_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_desc_length"
                  value={this.state.unit_desc_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_desc_script"
                  value={this.state.unit_desc_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="unit_desc_type"
                  value={this.state.unit_desc_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="unit_desc_tag"
                  type="text"
                  value={this.state.unit_desc_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_desc_hide"
                    value={this.state.unit_desc_hide}
                    checked={this.state.unit_desc_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_desc_readonly"
                    value={this.state.unit_desc_readonly}
                    checked={this.state.unit_desc_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="unit_desc_required"
                    value={this.state.unit_desc_required}
                    checked={this.state.unit_desc_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  id="unitDescModal"
                  onClick={(event) => this.onModal_Save(event)}
                  className="btn_save_pro"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onUnitDescModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.RateModalOpen}
          onHide={(event) => this.onRateModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onRateModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Rate Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="rate_dbfield"
                  value={this.state.rate_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="rate_validate"
                  value={this.state.rate_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="rate_length"
                  value={this.state.rate_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="rate_script"
                  value={this.state.rate_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="rate_type"
                  value={this.state.rate_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="rate_tag"
                  type="text"
                  value={this.state.rate_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="rate_hide"
                    value={this.state.rate_hide}
                    checked={this.state.rate_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="rate_readonly"
                    value={this.state.rate_readonly}
                    checked={this.state.rate_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="rate_required"
                    value={this.state.rate_required}
                    checked={this.state.rate_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  id="rate_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                  className="btn_save_pro"
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onRateModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.FactorModalOpen}
          onHide={(event) => this.onFactorModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onFactorModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Factor Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="factor_dbfield"
                  value={this.state.factor_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="factor_validate"
                  value={this.state.factor_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="factor_length"
                  value={this.state.factor_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="factor_script"
                  value={this.state.factor_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="factor_type"
                  value={this.state.factor_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="factor_tag"
                  type="text"
                  value={this.state.factor_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="factor_hide"
                    value={this.state.factor_hide}
                    checked={this.state.factor_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="factor_readonly"
                    value={this.state.factor_readonly}
                    checked={this.state.factor_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="factor_required"
                    value={this.state.factor_required}
                    checked={this.state.factor_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  id="factor_Modal"
                  className="btn_save_pro"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onFactorModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.AmountModalOpen}
          onHide={(event) => this.onAmountModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onAmountModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Amount Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="amount_dbfield"
                  value={this.state.amount_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="amount_validate"
                  value={this.state.amount_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="amount_length"
                  value={this.state.amount_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="amount_script"
                  value={this.state.amount_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="amount_type"
                  value={this.state.amount_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="amount_tag"
                  type="text"
                  value={this.state.amount_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="amount_hide"
                    value={this.state.amount_hide}
                    checked={this.state.amount_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="amount_readonly"
                    value={this.state.amount_readonly}
                    checked={this.state.amount_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="amount_required"
                    value={this.state.amount_required}
                    checked={this.state.amount_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="amount_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onAmountModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.CappedModalOpen}
          onHide={(event) => this.onCappedModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onCappedModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Capped Amount Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="capped_amount_dbfield"
                  value={this.state.capped_amount_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="capped_amount_validate"
                  value={this.state.capped_amount_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="capped_amount_length"
                  value={this.state.capped_amount_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="capped_amount_script"
                  value={this.state.capped_amount_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="capped_amount_type"
                  value={this.state.capped_amount_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="capped_amount_tag"
                  type="text"
                  value={this.state.capped_amount_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="capped_amount_hide"
                    value={this.state.capped_amount_hide}
                    checked={this.state.capped_amount_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="capped_amount_readonly"
                    value={this.state.capped_amount_readonly}
                    checked={this.state.capped_amount_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="capped_amount_required"
                    value={this.state.capped_amount_required}
                    checked={this.state.capped_amount_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="capped_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onCappedModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.DaysInWeekdModalOpen}
          onHide={(event) => this.onDaysInWeekModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onDaysInWeekModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Days In Week Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="days_in_week_dbfield"
                  value={this.state.days_in_week_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="days_in_week_validate"
                  value={this.state.days_in_week_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="days_in_week_length"
                  value={this.state.days_in_week_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="days_in_week_script"
                  value={this.state.days_in_week_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="days_in_week_type"
                  value={this.state.days_in_week_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="days_in_week_tag"
                  type="text"
                  value={this.state.days_in_week_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="days_in_week_hide"
                    value={this.state.days_in_week_hide}
                    checked={this.state.days_in_week_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="days_in_week_readonly"
                    value={this.state.days_in_week_readonly}
                    checked={this.state.days_in_week_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="days_in_week_required"
                    value={this.state.days_in_week_required}
                    checked={this.state.days_in_week_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="days_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onDaysInWeekModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.DateFromModalOpen}
          onHide={(event) => this.onDateFromModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onDateFromModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Days From Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="startDate_dbfield"
                  value={this.state.startDate_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="startDate_validate"
                  value={this.state.startDate_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="startDate_length"
                  value={this.state.startDate_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="startDate_script"
                  value={this.state.startDate_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="startDate_type"
                  value={this.state.startDate_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="startDate_tag"
                  type="text"
                  value={this.state.startDate_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="startDate_hide"
                    value={this.state.startDate_hide}
                    checked={this.state.startDate_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="startDate_readonly"
                    value={this.state.startDate_readonly}
                    checked={this.state.startDate_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="startDate_required"
                    value={this.state.startDate_required}
                    checked={this.state.startDate_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="startDate_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onDateFromModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.DateToModalOpen}
          onHide={(event) => this.onDateToModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onDateToModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Days To Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="endDate_dbfield"
                  value={this.state.endDate_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="endDate_validate"
                  value={this.state.endDate_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="endDate_length"
                  value={this.state.endDate_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="endDate_script"
                  value={this.state.endDate_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="endDate_type"
                  value={this.state.endDate_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="endDate_tag"
                  type="text"
                  value={this.state.endDate_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="endDate_hide"
                    value={this.state.endDate_hide}
                    checked={this.state.endDate_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="endDate_readonly"
                    value={this.state.endDate_readonly}
                    checked={this.state.endDate_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="endDate_required"
                    value={this.state.endDate_required}
                    checked={this.state.endDate_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="endDate_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"

                  onClick={(event) => this.onDateToModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.ChartModalOpen}
          onHide={(event) => this.onChartModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onChartModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Chart Sort Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_sort_dbfield"
                  value={this.state.chart_sort_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_sort_validate"
                  value={this.state.chart_sort_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_sort_length"
                  value={this.state.chart_sort_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_sort_script"
                  value={this.state.chart_sort_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="chart_sort_type"
                  value={this.state.chart_sort_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_sort_tag"
                  type="text"
                  value={this.state.chart_sort_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_sort_hide"
                    value={this.state.chart_sort_hide}
                    checked={this.state.chart_sort_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_sort_readonly"
                    value={this.state.chart_sort_readonly}
                    checked={this.state.chart_sort_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_sort_required"
                    value={this.state.chart_sort_required}
                    checked={this.state.chart_sort_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="chartS_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onChartModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.ChartCodeModalOpen}
          onHide={(event) => this.onChartCodeModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onChartCodeModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Chart Code Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_code_dbfield"
                  value={this.state.chart_code_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_code_validate"
                  value={this.state.chart_code_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_code_length"
                  value={this.state.chart_code_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_code_script"
                  value={this.state.chart_code_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="chart_code_type"
                  value={this.state.chart_code_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="chart_code_tag"
                  type="text"
                  value={this.state.chart_code_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_code_hide"
                    value={this.state.chart_code_hide}
                    checked={this.state.chart_code_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_code_readonly"
                    value={this.state.chart_code_readonly}
                    checked={this.state.chart_code_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="chart_code_required"
                    value={this.state.chart_code_required}
                    checked={this.state.chart_code_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="chartC_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onChartCodeModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.FlagModalOpen}
          onHide={(event) => this.onFlagModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onFlagModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Flag Settings</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="flag_dbfield"
                  value={this.state.flag_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="flag_validate"
                  value={this.state.flag_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="flag_length"
                  value={this.state.flag_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="flag_script"
                  value={this.state.flag_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="flag_type"
                  value={this.state.flag_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="flag_tag"
                  type="text"
                  value={this.state.flag_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="flag_hide"
                    value={this.state.flag_hide}
                    checked={this.state.flag_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="flag_readonly"
                    value={this.state.flag_readonly}
                    checked={this.state.flag_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="flag_required"
                    value={this.state.flag_required}
                    checked={this.state.flag_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="flag_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onFlagModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.PaymentFlagModalOpen}
          onHide={(event) => this.onPaymentFlagModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onPaymentFlagModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Payment Flag Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="payment_flag_dbfield"
                  value={this.state.payment_flag_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="payment_flag_validate"
                  value={this.state.payment_flag_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="payment_flag_length"
                  value={this.state.payment_flag_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="payment_flag_script"
                  value={this.state.payment_flag_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="payment_flag_type"
                  value={this.state.payment_flag_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="payment_flag_tag"
                  type="text"
                  value={this.state.payment_flag_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="payment_flag_hide"
                    value={this.state.payment_flag_hide}
                    checked={this.state.payment_flag_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="payment_flag_readonly"
                    value={this.state.payment_flag_readonly}
                    checked={this.state.payment_flag_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="payment_flag_required"
                    value={this.state.payment_flag_required}
                    checked={this.state.payment_flag_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="payment_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onPaymentFlagModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>

        <Modal
          show={this.state.CalcDaysModalOpen}
          onHide={(event) => this.onCalcDaysModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onCalcDaysModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Calc Days Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_days_dbfield"
                  value={this.state.calc_days_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_days_validate"
                  value={this.state.calc_days_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_days_length"
                  value={this.state.calc_days_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_days_script"
                  value={this.state.calc_days_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="calc_days_type"
                  value={this.state.calc_days_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_days_tag"
                  type="text"
                  value={this.state.calc_days_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_days_hide"
                    value={this.state.calc_days_hide}
                    checked={this.state.calc_days_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_days_readonly"
                    value={this.state.calc_days_readonly}
                    checked={this.state.calc_days_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_days_required"
                    value={this.state.calc_days_required}
                    checked={this.state.calc_days_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="calcD_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onCalcDaysModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>
        <Modal
          show={this.state.CalcWeeksModalOpen}
          onHide={(event) => this.onCalcWeeksModalClose()}
          id="unitdesc"
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onCalcWeeksModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">
              Calc Weeks Settings
            </h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyle modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                DB Field:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_weeks_dbfield"
                  value={this.state.calc_weeks_dbfield}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Validate:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_weeks_validate"
                  value={this.state.calc_weeks_validate}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Length:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_weeks_length"
                  value={this.state.calc_weeks_length}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Script:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_weeks_script"
                  value={this.state.calc_weeks_script}
                  onChange={(event) => this.handleUserInput(event)}
                  type="text"
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  name="calc_weeks_type"
                  value={this.state.calc_weeks_type}
                  onChange={(event) => this.handleUserInput(event)}
                >
                  <option value="">Select</option>
                  <option value="String">String</option>
                  <option value="Text">Text</option>
                  <option value="Date">Date</option>
                  <option value="Numeric">Numeric</option>
                </select>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Tag:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="calc_weeks_tag"
                  type="text"
                  value={this.state.calc_weeks_tag}
                  onChange={(event) => this.handleUserInput(event)}
                />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Hide:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_weeks_hide"
                    value={this.state.calc_weeks_hide}
                    checked={this.state.calc_weeks_hide}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Read Only:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_weeks_readonly"
                    value={this.state.calc_weeks_readonly}
                    checked={this.state.calc_weeks_readonly}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Required:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <label className="check_box_pop">
                  <input
                    type="checkbox"
                    name="calc_weeks_required"
                    value={this.state.calc_weeks_required}
                    checked={this.state.calc_weeks_required}
                    onChange={(event) => this.handleUserInputCheckbox(event)}
                  />
                  <span className="checkmark report_checkmark"></span>
                </label>
              </div>
            </div>

            <div className="clear30"></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                <button
                  type="button"
                  className="btn_save_pro"
                  id="calcW_Modal"
                  onClick={(event) => this.onModal_Save(event)}
                >
                  Save
                </button>
                <button
                  type="button"
                  onClick={(event) => this.onCalcWeeksModalClose()}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
            <div className="clear20"></div>
          </div>
        </Modal>

        <Modal
          show={this.state.setupModalOpen}
          onHide={(event) => this.onsetupModalClose()}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={(event) => this.onsetupModalClose()}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Setup Form</h4>
          </div>
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyleSetup modal_pop_list_scroll ">
            <div className="col-xs-12 p0 hdg_edit_detail_1">
              <div className="col-xs-6 p0">
                <h4>Codes</h4>
              </div>
            </div>

            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Chart Sort
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                {" "}
                <input
                  id="setup_chartSort"
                  name="setup_chartSort"
                  value={this.state.setup_chartSort}
                  onChange={this.setup_inputHandler}
                  type="text"
                  placeholder="XX-XX-XXX"
                />
                {" "}
                {this.state.setup_chartSortErr ? (
                  <p className="error validation" style={{ color: "red" }}>
                    {this.state.setup_chartSortErr}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Chart Code
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  id="setup_chartCode"
                  name="setup_chartCode"
                  value={this.state.setup_chartCode}
                  onChange={this.setup_inputHandler}
                  type="text"
                  placeholder="XXXX-XXXX-XXX"
                />{" "}
                {this.state.setup_chartCodeErr ? (
                  <p className="error validation" style={{ color: "red" }}>
                    {this.state.setup_chartCodeErr}
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className=" clear10" />
              <div className="col-xs-12 p0 hdg_edit_detail_2_setup">
                <div className="col-xs-6 p0">
                  <h4>Tracking Fields</h4>
                </div>
              </div>
              <div className="setupFields_plus_button">
                <a
                  href={null}
                  onClick={this.onsetup_editModalopen}
                  className="cursorPointer"
                  data-toggle="modal"
                  data-target="#approval_setup"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                  >
                    <path
                      id="ic_add_24px"
                      d="M20,13.571H13.571V20H11.429V13.571H5V11.429h6.429V5h2.143v6.429H20Z"
                      transform="translate(-5 -5)"
                      fill="#7b7b7b"
                    />
                  </svg>
                </a>
              </div>
              <div className="clear10" />
              <div className="col-md-12 col-lg-12 p0 setup_edit_pop_input">
                <table
                  width="100%"
                  className="table table-bordered table-responsive"
                >
                  <thead>
                    <tr className="table_header_adtimes">
                      <th colSpan="5" align="center" className="th_p0">
                        <div className="header_setup_team_pop3">
                          <table
                            width="100%"
                            border="0"
                            cellSpacing="2"
                            cellPadding="2"
                          >
                            <tbody>
                              <tr className="bdr_tr_none">
                                <td>&nbsp;</td>
                                <td align="center">Order</td>
                                <td align="center">Length</td>
                                <td>Description</td>
                                <td>Actions</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.trackingList.map((item) => {
                      return (
                        <tr key={item.uuid}>
                          <td align="left" width="12%">
                            <div className="checkbox">
                              <input id="checkbox" type="checkbox" />
                              <label htmlFor="checkbox"> </label>
                            </div>
                          </td>
                          <td align="left" width="17%">
                            {item.Order}
                          </td>
                          <td align="left" width="16%">
                            {item.Length}
                          </td>
                          <td align="left" width="31%">
                            {item.Prompt}
                          </td>
                          <td align="left">
                            <a
                              href={null}
                              onClick={(event) =>
                                this.openUpdateModal(item.uuid)
                              }
                              className="setup_team_pop3_svg"
                              data-toggle="modal"
                              data-target="#approval_setup"
                            >
                              {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  id="ic_create_24px"
                                  className="cls-1"
                                  d="M3,18.831V23H7.166L19.453,10.71,15.287,6.544ZM22.675,7.489a1.106,1.106,0,0,0,0-1.566l-2.6-2.6a1.106,1.106,0,0,0-1.566,0L16.476,5.356l4.166,4.166,2.033-2.033Z"
                                  transform="translate(-3 -2.998)"
                                />
                              </svg> */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="1656.776 299 17.515 18.003"
                              >
                                <path
                                  id="ic_create_24px5"
                                  className="cls-1"
                                  d="M3,17.25V21H6.648L17.409,9.94,13.761,6.19ZM20.23,7.04a1.016,1.016,0,0,0,0-1.41L17.954,3.29a.95.95,0,0,0-1.372,0L14.8,5.12,18.45,8.87l1.78-1.83Z"
                                  transform="translate(1653.776 296.002)"
                                />
                              </svg>
                            </a>{" "}
                            <a
                              href="javascript:void(0);"
                              onClick={(event) =>
                                this.deleteTrackingObject(item.uuid)
                              }
                              className="setup_team_pop3_svg"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="1700 296 15 19.286"
                              >
                                <path
                                  id="ic_delete_24px5"
                                  className="cls-1"
                                  d="M6.071,20.143a2.149,2.149,0,0,0,2.143,2.143h8.571a2.149,2.149,0,0,0,2.143-2.143V7.286H6.071ZM20,4.071H16.25L15.179,3H9.821L8.75,4.071H5V6.214H20Z"
                                  transform="translate(1695 293)"
                                />
                              </svg>
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div className="clear30"></div>
              <div className="col-sm-6">
                <div className="btn_cance_save">
                  <button
                    type="button"
                    className="btn_save_pro"
                    onClick={this.handleSubmitSetupForm}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    onClick={(event) => this.onsetupModalClose()}
                    className="btn_cancel_pro"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          show={this.state.setupTrackingFieldEditModal}
          onHide={this.onsetup_editModalclose}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={this.onsetup_editModalclose}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Tracking Fields</h4>
          </div>{" "}
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyleSetup modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Order
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <input
                  name="tracking_order"
                  value={this.state.tracking_order}
                  type="number"
                  onChange={this.UserInputsChngHandler}
                />
                {this.state.tracking_order_error ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Order Field is required
                  </p>
                ) : (
                  ""
                )}
                {this.state.order_present_before ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Order can not be repeated, Try another
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-12 col-sm-4 col-md-4 label_csutom_pop">
                Type:
              </div>
              <div className="col-xs-12 col-sm-8 col-md-8">
                <select
                  id="typeofdefaultValue"
                  name="typeOfTrackingField"
                  value={this.state.typeOfTrackingField}
                  onChange={this.change_type}
                >
                  <option value="String">String</option>
                  <option value="Numeric">Numeric</option>
                  <option value="Date">Date</option>
                  <option value="DropList">Drop List</option>
                </select>
              </div>
            </div>
            <div></div>
            <div className="clearfix"></div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-5 col-sm-4 col-md-4 label_dataentry_approv">
                Default Value:
              </div>
              <div className="col-xs-7 col-sm-6 col-md-8">
                <input
                  id="d_value_input"
                  value={this.state.d_value_input}
                  onChange={this.UserInputsChngHandler}
                  type="text"
                  name="d_value_input"
                />

                <div id="d_value_dropdown" className="d_value_dropdown_styles">
                  <select
                    name="d_value_options"
                    value={this.state.d_value_options}
                    onChange={this.UserInputsChngHandler}
                  >
                    <option value="String">Select Option</option>
                    {this.state.dropdown_elements.map((item) => {
                      return (
                        <option key={item.key} value={item.option}>
                          {item.option}
                        </option>
                      );
                    })}
                  </select>

                  <a
                    hreaf="javascript:void(0);"
                    className="plus_icon_setup cursorPointer plus_btn_options"
                    onClick={this.ondrop_listModalOpen}
                    data-toggle="modal"
                    data-target="#approval_setup_2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                    >
                      <path
                        id="ic_add_24px"
                        d="M20,13.571H13.571V20H11.429V13.571H5V11.429h6.429V5h2.143v6.429H20Z"
                        transform="translate(-5 -5)"
                        fill="#7B7B7B"
                      />
                    </svg>
                  </a>
                </div>
                {this.state.tracking_d_value_input_error &&
                this.state.dropdown_elements.length === 0 ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Default value is required
                  </p>
                ) : (
                  ""
                )}
                {this.state.d_input_options_errors &&
                this.state.dropdown_elements.length !== 0 ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Option value is required
                  </p>
                ) : (
                  ""
                )}
                <div
                  id="date_input_trackingfields"
                  className="d_value_dropdown_styles"
                >
                  <DatePicker
                    id="datepickerfortrackingfields"
                    selected={this.state.trackingfiled_date}
                    onChange={this.handleDateChange}
                  />
                  <svg
                    onClick={this.openCalenderForTrackingFields}
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                  >
                    <path
                      id="ic_date_range_24px"
                      d="M9,11H7v2H9Zm4,0H11v2h2Zm4,0H15v2h2Zm2-7H18V2H16V4H8V2H6V4H5A1.991,1.991,0,0,0,3.01,6L3,20a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,19,4Zm0,16H5V9H19Z"
                      transform="translate(-3 -2)"
                      fill="#30679a"
                    ></path>
                  </svg>
                </div>

                {this.state.trackingfiled_date_error &&
                this.state.dropdown_elements.length === 0 &&
                $("#typeofdefaultValue").val() === "Date" ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Date field is required
                  </p>
                ) : (
                  ""
                )}
                <div className=" clearfix" />
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-5 col-sm-4 col-md-4 label_dataentry_approv">
                Length
              </div>
              <div className="col-xs-7 col-sm-6 col-md-8">
                <input
                  name="tracking_length"
                  value={this.state.tracking_length}
                  type="number"
                  onChange={this.UserInputsChngHandler}
                />
                {this.state.tracking_length_error ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Length Field is required
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-5 col-sm-4 col-md-4 label_dataentry_approv">
                Description
              </div>

              <div className="col-xs-7 col-sm-6 col-md-8">
                <input
                  name="tracking_prompt"
                  value={this.state.tracking_prompt}
                  type="text"
                  onChange={this.UserInputsChngHandler}
                />
                {this.state.tracking_prompt_error ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Promp Field is required
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                {this.state.updateDataModal ? (
                  <button
                    type="button"
                    className="btn_save_pro "
                    onClick={(event) => this.updateTrackingFields()}
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn_save_pro "
                    onClick={(event) => this.saveTrackingFields()}
                  >
                    Save
                  </button>
                )}
                <button
                  type="button"
                  onClick={this.onsetup_editModalclose}
                  className="btn_cancel_pro"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          show={this.state.drop_listModal}
          onHide={this.ondrop_listModalClose}
          className="modal modal2 fade"
          role="dialog"
        >
          <div className="modal-header">
            <button
              type="button"
              onClick={this.ondrop_listModalClose}
              className="close OutlineNone"
              data-dismiss="modal"
            >
              <img
                className="mt22"
                src={ic_clear_24px}
                width="18"
                height="18"
                alt=""
              />
            </button>
            <h4 className="modal-title modal_customefield">Tracking Fields</h4>
          </div>{" "}
          <div className="modal-body label_modal_custom pdg_modal_csutom_leist customfieldslist_modalBodyCustomStyleSetup modal_pop_list_scroll ">
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="clear10" />
              <div className="col-md-12 col-lg-12 p0 setup_edit_pop_input">
                <div className="modal-body">
                  <table
                    className="table table-bordered table-responsive"
                    width="100%"
                  >
                    <thead>
                      <tr className="drop_list_tableHead">
                        <th align="center"> Option </th>
                        <th align="center"> Value </th>
                        <th align="center"> Actions </th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.dropdown_elements.map((item) => {
                        return (
                          <tr key={item.key}>
                            <td align="center">{item.option}</td>
                            <td>{item.value}</td>
                            <td>
                              <a
                                href={null}
                                onClick={(event) =>
                                  this.editDropListButtonClicked(item.key)
                                }
                                className="setup_team_pop3_svg"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    id="ic_create_24px"
                                    className="cls-1"
                                    d="M3,18.831V23H7.166L19.453,10.71,15.287,6.544ZM22.675,7.489a1.106,1.106,0,0,0,0-1.566l-2.6-2.6a1.106,1.106,0,0,0-1.566,0L16.476,5.356l4.166,4.166,2.033-2.033Z"
                                    transform="translate(-3 -2.998)"
                                  />
                                </svg>
                              </a>{" "}
                              <a
                                href="javascript:void(0);"
                                onClick={(event) =>
                                  this.deleteOptionValue(item.key)
                                }
                                className="setup_team_pop3_svg"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="10.111"
                                  height="13"
                                  viewBox="0 0 10.111 13"
                                >
                                  <path
                                    id="ic_delete_24px"
                                    d="M5.722,14.556A1.449,1.449,0,0,0,7.167,16h5.778a1.449,1.449,0,0,0,1.444-1.444V5.889H5.722ZM15.111,3.722H12.583L11.861,3H8.25l-.722.722H5V5.167H15.111Z"
                                    transform="translate(-5 -3)"
                                    fill="#7b7b7b"
                                  />
                                </svg>
                              </a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-sm-12 p0 mrg_bot_custom10">
              <h4 className="modal-title modal_customefield drop_list_modal_title">
                {this.state.editDropDown ? (
                  <React.Fragment>
                    {" "}
                    <h4 style={{ display: "inline" }}>
                      Cancel Update &nbsp;&nbsp;
                    </h4>
                    <img
                      onClick={this.cancel_update_option}
                      style={{ width: "15px", height: "15px" }}
                      src="data:image/svg+xml;utf8;base64,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"
                    />{" "}
                  </React.Fragment>
                ) : (
                  "Add new options"
                )}
              </h4>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-5 col-sm-4 col-md-4 label_dataentry_approv">
                Option
              </div>
              <div className="col-xs-7 col-sm-6 col-md-8">
                <input
                  name="options"
                  value={this.state.options}
                  type="text"
                  onChange={this.UserInputsChngHandler}
                />
                {this.state.options_error ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Option Field is required
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="col-sm-12 p0 mrg_bot_custom10">
              <div className="col-xs-5 col-sm-4 col-md-4 label_dataentry_approv">
                Value
              </div>
              <div className="col-xs-7 col-sm-6 col-md-8">
                <input
                  name="values"
                  value={this.state.values}
                  type="text"
                  onChange={this.UserInputsChngHandler}
                />
                {this.state.values_error ? (
                  <p className="error validation" style={{ color: "red" }}>
                    Value Field is required
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div></div>
            <div className="col-sm-6">
              <div className="btn_cance_save">
                {this.state.editDropDown ? (
                  <button
                    type="button"
                    onClick={this.onUpdateDropDownValues}
                    className="btn_save_pro"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={this.onDropDownValuesSave}
                    className="btn_save_pro"
                  >
                    Save
                  </button>
                )}{" "}
                <button
                  type="button"
                  onClick={this.ondrop_listModalClose}
                  className="btn_cancel_pro"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default CustomFieldsList;
